// DO NOT EDIT -- generated from fs/services/warehauser/warehauser.proto

import * as protobuf from '../../../google/protobuf';
import * as radia from '../radia';
import * as schema from '../../shared/schema';

export namespace WarehouseSyncService {

  export const MigrateCronsToCloudEndpoint = "/grpc/warehauser.WarehouseSyncService/MigrateCronsToCloud";
  export function MigrateCronsToCloud(sender: (req: MigrateCronsToCloudRequest, endpoint: string) => Promise<MigrateCronsToCloudResponse>, req: MigrateCronsToCloudRequest): { promise: () => Promise<MigrateCronsToCloudResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MigrateCronsToCloudEndpoint),
      endpoint: MigrateCronsToCloudEndpoint
    };
  }

  export const GetSyncTaskEndpoint = "/grpc/warehauser.WarehouseSyncService/GetSyncTask";
  /** GetSyncTask will return the sync task for a given ID. */
  export function GetSyncTask(sender: (req: GetSyncTaskRequest, endpoint: string) => Promise<GetSyncTaskResponse>, req: GetSyncTaskRequest): { promise: () => Promise<GetSyncTaskResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSyncTaskEndpoint),
      endpoint: GetSyncTaskEndpoint
    };
  }

  export const StartSyncEndpoint = "/grpc/warehauser.WarehouseSyncService/StartSync";
  /**
   * StartSync starts the periodic sync of data for an org to the configured warehouses, if not already started.
   * The sync will run according to the schedule of the org, and may not immediately run after being started.
   */
  export function StartSync(sender: (req: StartSyncRequest, endpoint: string) => Promise<{}>, req: StartSyncRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StartSyncEndpoint),
      endpoint: StartSyncEndpoint
    };
  }

  export const TriggerSyncEndpoint = "/grpc/warehauser.WarehouseSyncService/TriggerSync";
  /** TriggerSync triggers an immediate sync of data for an org to the configured warehouse, if not already running. */
  export function TriggerSync(sender: (req: TriggerSyncRequest, endpoint: string) => Promise<{}>, req: TriggerSyncRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, TriggerSyncEndpoint),
      endpoint: TriggerSyncEndpoint
    };
  }

  export const TriggerTransformEndpoint = "/grpc/warehauser.WarehouseSyncService/TriggerTransform";
  export function TriggerTransform(sender: (req: TriggerTransformRequest, endpoint: string) => Promise<{}>, req: TriggerTransformRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, TriggerTransformEndpoint),
      endpoint: TriggerTransformEndpoint
    };
  }

  export const StopSyncEndpoint = "/grpc/warehauser.WarehouseSyncService/StopSync";
  /**
   * StopSync stops the periodic sync of data for an org to the configured warehouses. The stop just makes sure no new
   * sync will run and the current running sync will not be affected.
   */
  export function StopSync(sender: (req: StopSyncRequest, endpoint: string) => Promise<{}>, req: StopSyncRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StopSyncEndpoint),
      endpoint: StopSyncEndpoint
    };
  }

  export const SetSyncIntervalEndpoint = "/grpc/warehauser.WarehouseSyncService/SetSyncInterval";
  /** SetSyncInterval sets the sync interval for an org and maintain the start/stop status of the sync with best effort. */
  export function SetSyncInterval(sender: (req: SetSyncIntervalRequest, endpoint: string) => Promise<{}>, req: SetSyncIntervalRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetSyncIntervalEndpoint),
      endpoint: SetSyncIntervalEndpoint
    };
  }

  export const PutSyncTaskEndpoint = "/grpc/warehauser.WarehouseSyncService/PutSyncTask";
  /**
   * PutSyncTask puts a sync task for an org to be processed asynchronously based on the warehouse configurations of the
   * org. Putting the same task is idempotent only before the task is processed.
   */
  export function PutSyncTask(sender: (req: PutSyncTaskRequest, endpoint: string) => Promise<PutSyncTaskResponse>, req: PutSyncTaskRequest): { promise: () => Promise<PutSyncTaskResponse>, endpoint: string } {
    return {
      promise: () => sender(req, PutSyncTaskEndpoint),
      endpoint: PutSyncTaskEndpoint
    };
  }

  export const PeekSyncTasksEndpoint = "/grpc/warehauser.WarehouseSyncService/PeekSyncTasks";
  /**
   * PeekSyncTasks peeks sync tasks from all the queues of an org, and does not change any state.
   * Each org has a warehouse agnostic queue and has a queue for each combination of warehouses and kinds.
   */
  export function PeekSyncTasks(sender: (req: PeekSyncTasksRequest, endpoint: string) => Promise<PeekSyncTasksResponse>, req: PeekSyncTasksRequest): { promise: () => Promise<PeekSyncTasksResponse>, endpoint: string } {
    return {
      promise: () => sender(req, PeekSyncTasksEndpoint),
      endpoint: PeekSyncTasksEndpoint
    };
  }

  export const RemoveSyncTasksEndpoint = "/grpc/warehauser.WarehouseSyncService/RemoveSyncTasks";
  /**
   * RemoveSyncTasks removes sync tasks from one of the queues of an org. If a sync task to be removed is already being
   * processed, the processing will not be affected. It is an no-op to remove a sync task that does not exist.
   */
  export function RemoveSyncTasks(sender: (req: RemoveSyncTasksRequest, endpoint: string) => Promise<{}>, req: RemoveSyncTasksRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RemoveSyncTasksEndpoint),
      endpoint: RemoveSyncTasksEndpoint
    };
  }

  export const ReconcileSyncEndpoint = "/grpc/warehauser.WarehouseSyncService/ReconcileSync";
  /** ReconcileSync will iterate all org IDs with configs and call ReconcileOrg for them. */
  export function ReconcileSync(sender: (req: {}, endpoint: string) => Promise<ReconcileSyncResponse>, req: {}): { promise: () => Promise<ReconcileSyncResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ReconcileSyncEndpoint),
      endpoint: ReconcileSyncEndpoint
    };
  }

  export const ReconcileOrgEndpoint = "/grpc/warehauser.WarehouseSyncService/ReconcileOrg";
  /**
   * ReconcileOrg will check to see that the org still has the DD pack. If not,
   * the config will be deleted, the sync workflow will be stopped and tasks queues will be purged.
   */
  export function ReconcileOrg(sender: (req: ReconcileOrgRequest, endpoint: string) => Promise<ReconcileOrgResponse>, req: ReconcileOrgRequest): { promise: () => Promise<ReconcileOrgResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ReconcileOrgEndpoint),
      endpoint: ReconcileOrgEndpoint
    };
  }

  export const GetSyncHistoryEndpoint = "/grpc/warehauser.WarehouseSyncService/GetSyncHistory";
  export function GetSyncHistory(sender: (req: GetSyncHistoryRequest, endpoint: string) => Promise<GetSyncHistoryResponse>, req: GetSyncHistoryRequest): { promise: () => Promise<GetSyncHistoryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSyncHistoryEndpoint),
      endpoint: GetSyncHistoryEndpoint
    };
  }
}

export namespace DxoSyncService {

  export const GetDxoPrepStatusEndpoint = "/grpc/warehauser.DxoSyncService/GetDxoPrepStatus";
  export function GetDxoPrepStatus(sender: (req: GetDxoPrepStatusRequest, endpoint: string) => Promise<GetDxoPrepStatusResponse>, req: GetDxoPrepStatusRequest): { promise: () => Promise<GetDxoPrepStatusResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDxoPrepStatusEndpoint),
      endpoint: GetDxoPrepStatusEndpoint
    };
  }

  export const SetDxoPrepStatusEndpoint = "/grpc/warehauser.DxoSyncService/SetDxoPrepStatus";
  export function SetDxoPrepStatus(sender: (req: SetDxoPrepStatusRequest, endpoint: string) => Promise<{}>, req: SetDxoPrepStatusRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetDxoPrepStatusEndpoint),
      endpoint: SetDxoPrepStatusEndpoint
    };
  }
}

export namespace InternalSyncService {

  export const SetInternalSyncEndpoint = "/grpc/warehauser.InternalSyncService/SetInternalSync";
  /** SetInternalSync is a wrapper around UpsertConfig/DeleteConfig and SetSyncStatus to safely set internal sync config. */
  export function SetInternalSync(sender: (req: SetInternalSyncRequest, endpoint: string) => Promise<{}>, req: SetInternalSyncRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetInternalSyncEndpoint),
      endpoint: SetInternalSyncEndpoint
    };
  }

  export const GetAllInternalSyncsEndpoint = "/grpc/warehauser.InternalSyncService/GetAllInternalSyncs";
  /**
   * GetAllInternalSyncs gets all internal sync configs. This endpoint is for information purpose only and is not
   * efficient enough for medium to high traffic.
   */
  export function GetAllInternalSyncs(sender: (req: {}, endpoint: string) => Promise<GetAllInternalSyncsResponse>, req: {}): { promise: () => Promise<GetAllInternalSyncsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllInternalSyncsEndpoint),
      endpoint: GetAllInternalSyncsEndpoint
    };
  }
}

export namespace ObjectStorageSyncService {

  export const InitializeObjectStorageHistoricalSyncEndpoint = "/grpc/warehauser.ObjectStorageSyncService/InitializeObjectStorageHistoricalSync";
  /**
   * InitializeObjectStorageHistoricalSync initializes the historical object storage sync for an org that will run
   * asynchronously. If the historical sync has been initialized before, this will be no-op.
   */
  export function InitializeObjectStorageHistoricalSync(sender: (req: InitializeObjectStorageHistoricalSyncRequest, endpoint: string) => Promise<{}>, req: InitializeObjectStorageHistoricalSyncRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, InitializeObjectStorageHistoricalSyncEndpoint),
      endpoint: InitializeObjectStorageHistoricalSyncEndpoint
    };
  }

  export const GetObjectStoragePrepStatusEndpoint = "/grpc/warehauser.ObjectStorageSyncService/GetObjectStoragePrepStatus";
  /** GetObjectStoragePrepStatus gets the prep status of the object storage sync (including historical sync) for an org. */
  export function GetObjectStoragePrepStatus(sender: (req: GetObjectStoragePrepStatusRequest, endpoint: string) => Promise<GetObjectStoragePrepStatusResponse>, req: GetObjectStoragePrepStatusRequest): { promise: () => Promise<GetObjectStoragePrepStatusResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetObjectStoragePrepStatusEndpoint),
      endpoint: GetObjectStoragePrepStatusEndpoint
    };
  }

  export const GetObjectStorageBundlePagesEndpoint = "/grpc/warehauser.ObjectStorageSyncService/GetObjectStorageBundlePages";
  /** GetObjectStorageBundlePages gets the page ids in an object storage bundle for an org. */
  export function GetObjectStorageBundlePages(sender: (req: GetObjectStorageBundlePagesRequest, endpoint: string) => Promise<GetObjectStorageBundlePagesResponse>, req: GetObjectStorageBundlePagesRequest): { promise: () => Promise<GetObjectStorageBundlePagesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetObjectStorageBundlePagesEndpoint),
      endpoint: GetObjectStorageBundlePagesEndpoint
    };
  }

  export const GetObjectStoragePageBundleEndpoint = "/grpc/warehauser.ObjectStorageSyncService/GetObjectStoragePageBundle";
  /** GetObjectStoragePageBundle gets the id of the object storage bundle that contains a page for an org. */
  export function GetObjectStoragePageBundle(sender: (req: schema.PageArgsProto, endpoint: string) => Promise<GetObjectStoragePageBundleResponse>, req: schema.PageArgsProto): { promise: () => Promise<GetObjectStoragePageBundleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetObjectStoragePageBundleEndpoint),
      endpoint: GetObjectStoragePageBundleEndpoint
    };
  }
}

export namespace WarehouseMonitoringService {

  export const StartMonitoringEndpoint = "/grpc/warehauser.WarehouseMonitoringService/StartMonitoring";
  /**
   * StartMonitoring starts the monitoring service that will periodically check the status for alerting. If the service
   * has already started, nothing happens. Only one instance of the service will be running among all the pods.
   */
  export function StartMonitoring(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StartMonitoringEndpoint),
      endpoint: StartMonitoringEndpoint
    };
  }

  export const StopMonitoringEndpoint = "/grpc/warehauser.WarehouseMonitoringService/StopMonitoring";
  /**
   * StopMonitoring stops the monitoring service, usually temporarily for updating the code. If the monitoring service
   * has stopped for extended time, alerts will be triggered.
   */
  export function StopMonitoring(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StopMonitoringEndpoint),
      endpoint: StopMonitoringEndpoint
    };
  }

  export const RefreshMonitoringStatusEndpoint = "/grpc/warehauser.WarehouseMonitoringService/RefreshMonitoringStatus";
  /**
   * RefreshMonitoringStatus immediately refreshes the status for alerting and returns the status. Refreshed status
   * might trigger or stop alerts. Internally, the status will be refreshed automatically according to some schedule.
   */
  export function RefreshMonitoringStatus(sender: (req: {}, endpoint: string) => Promise<MonitoringStatus>, req: {}): { promise: () => Promise<MonitoringStatus>, endpoint: string } {
    return {
      promise: () => sender(req, RefreshMonitoringStatusEndpoint),
      endpoint: RefreshMonitoringStatusEndpoint
    };
  }

  export const GetMonitoringStatusEndpoint = "/grpc/warehauser.WarehouseMonitoringService/GetMonitoringStatus";
  /** GetMonitoringStatus gets the last refreshed status for alerting without refreshing the status immediately. */
  export function GetMonitoringStatus(sender: (req: {}, endpoint: string) => Promise<MonitoringStatus>, req: {}): { promise: () => Promise<MonitoringStatus>, endpoint: string } {
    return {
      promise: () => sender(req, GetMonitoringStatusEndpoint),
      endpoint: GetMonitoringStatusEndpoint
    };
  }

  export const SnoozeOrgWarehouseEndpoint = "/grpc/warehauser.WarehouseMonitoringService/SnoozeOrgWarehouse";
  /**
   * SnoozeOrgWarehouse snoozes a warehouse configuration for an org when the org warehouse would otherwise trigger
   * alerts. The snooze will last up to the specified duration. During the snooze, if the org warehouse can sync
   * successfully after retry or the configuration is updated, the snooze will be automatically removed. Note that this
   * endpoint is for manual snooze. There is the separate automatic snooze for user errors. Use this endpoint for
   * temporary overriding on unidentified user errors or bugs being fixed.
   */
  export function SnoozeOrgWarehouse(sender: (req: SnoozeOrgWarehouseRequest, endpoint: string) => Promise<{}>, req: SnoozeOrgWarehouseRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SnoozeOrgWarehouseEndpoint),
      endpoint: SnoozeOrgWarehouseEndpoint
    };
  }

  export const UnsnoozeOrgWarehouseEndpoint = "/grpc/warehauser.WarehouseMonitoringService/UnsnoozeOrgWarehouse";
  /**
   * UnsnoozeOrgWarehouse unsnoozes a warehouse configuration for an org before the snooze is automatically removed.
   * See SnoozeOrgWarehouse for the details on the automatic removal that applies to both the automatic snooze and the
   * manual snooze. This endpoint is mostly for canceling a snooze.
   */
  export function UnsnoozeOrgWarehouse(sender: (req: UnsnoozeOrgWarehouseRequest, endpoint: string) => Promise<{}>, req: UnsnoozeOrgWarehouseRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UnsnoozeOrgWarehouseEndpoint),
      endpoint: UnsnoozeOrgWarehouseEndpoint
    };
  }

  export const CompareWarehouseEventsEndpoint = "/grpc/warehauser.WarehouseMonitoringService/CompareWarehouseEvents";
  /** CompareWarehouseEvents compares the events in the warehouse with the events from an adhoc bundle. */
  export function CompareWarehouseEvents(sender: (req: CompareWarehouseEventsRequest, endpoint: string) => Promise<CompareWarehouseEventsResponse>, req: CompareWarehouseEventsRequest): { promise: () => Promise<CompareWarehouseEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CompareWarehouseEventsEndpoint),
      endpoint: CompareWarehouseEventsEndpoint
    };
  }
}

export namespace WarehouseQualityMonitoringService {

  export const StartQualityMonitoringEndpoint = "/grpc/warehauser.WarehouseQualityMonitoringService/StartQualityMonitoring";
  /**
   * StartMonitoring starts the quality monitoring service that will periodically check the status for alerting. If the service
   * has already started, nothing happens. Only one instance of the service will be running among all the pods.
   */
  export function StartQualityMonitoring(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StartQualityMonitoringEndpoint),
      endpoint: StartQualityMonitoringEndpoint
    };
  }

  export const StopQualityMonitoringEndpoint = "/grpc/warehauser.WarehouseQualityMonitoringService/StopQualityMonitoring";
  /** StopMonitoring stops the quality monitoring service, usually temporarily for updating the code. */
  export function StopQualityMonitoring(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StopQualityMonitoringEndpoint),
      endpoint: StopQualityMonitoringEndpoint
    };
  }
}

export namespace WarehouseBackfillService {

  export const TriggerBackfillWorkflowEndpoint = "/grpc/warehauser.WarehouseBackfillService/TriggerBackfillWorkflow";
  /**
   * TriggerBackfillWorkflow will run the backfill workflow for the provided orgs, picking up any scheduled,
   * or in-progress work.
   */
  export function TriggerBackfillWorkflow(sender: (req: TriggerBackfillWorkflowRequest, endpoint: string) => Promise<{}>, req: TriggerBackfillWorkflowRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, TriggerBackfillWorkflowEndpoint),
      endpoint: TriggerBackfillWorkflowEndpoint
    };
  }

  export const CreateBackfillEndpoint = "/grpc/warehauser.WarehouseBackfillService/CreateBackfill";
  /**
   * CreateBackfill queues a backfill to be processed asynchronously. If scheduling an internal
   * backfill, use CreateInternalBackfill instead.
   */
  export function CreateBackfill(sender: (req: CreateBackfillRequest, endpoint: string) => Promise<CreateBackfillResponse>, req: CreateBackfillRequest): { promise: () => Promise<CreateBackfillResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateBackfillEndpoint),
      endpoint: CreateBackfillEndpoint
    };
  }

  export const CreateInternalBackfillEndpoint = "/grpc/warehauser.WarehouseBackfillService/CreateInternalBackfill";
  /**
   * CreateInternalBackfill queues a backfill to be processed asynchronously. If scheduling a backfill
   * for a customer, use CreateBackfill instead.
   */
  export function CreateInternalBackfill(sender: (req: CreateInternalBackfillRequest, endpoint: string) => Promise<CreateInternalBackfillResponse>, req: CreateInternalBackfillRequest): { promise: () => Promise<CreateInternalBackfillResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateInternalBackfillEndpoint),
      endpoint: CreateInternalBackfillEndpoint
    };
  }

  export const CreateBackfillsForOrgsEndpoint = "/grpc/warehauser.WarehouseBackfillService/CreateBackfillsForOrgs";
  /**
   * CreateBackfillsForOrgs queues a backfill to be processed asynchronously for all orgs
   * by default. You should choose a small time range here, otherwise the load may be too
   * great.
   */
  export function CreateBackfillsForOrgs(sender: (req: CreateBackfillsForOrgsRequest, endpoint: string) => Promise<CreateBackfillsForOrgsResponse>, req: CreateBackfillsForOrgsRequest): { promise: () => Promise<CreateBackfillsForOrgsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateBackfillsForOrgsEndpoint),
      endpoint: CreateBackfillsForOrgsEndpoint
    };
  }

  export const GetBackfillEndpoint = "/grpc/warehauser.WarehouseBackfillService/GetBackfill";
  /** GetBackfill returns the requested backfill. */
  export function GetBackfill(sender: (req: GetBackfillRequest, endpoint: string) => Promise<GetBackfillResponse>, req: GetBackfillRequest): { promise: () => Promise<GetBackfillResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetBackfillEndpoint),
      endpoint: GetBackfillEndpoint
    };
  }

  export const ListBackfillsEndpoint = "/grpc/warehauser.WarehouseBackfillService/ListBackfills";
  /** ListBackfills returns backfill matching the request filters. */
  export function ListBackfills(sender: (req: ListBackfillsRequest, endpoint: string) => Promise<ListBackfillResponse>, req: ListBackfillsRequest): { promise: () => Promise<ListBackfillResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListBackfillsEndpoint),
      endpoint: ListBackfillsEndpoint
    };
  }

  export const CancelBackfillEndpoint = "/grpc/warehauser.WarehouseBackfillService/CancelBackfill";
  export function CancelBackfill(sender: (req: CancelBackfillRequest, endpoint: string) => Promise<CancelBackfillResponse>, req: CancelBackfillRequest): { promise: () => Promise<CancelBackfillResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CancelBackfillEndpoint),
      endpoint: CancelBackfillEndpoint
    };
  }
}

export namespace WarehouseConfigService {

  export const GetConfigEndpoint = "/grpc/warehauser.WarehouseConfigService/GetConfig";
  export function GetConfig(sender: (req: GetConfigRequest, endpoint: string) => Promise<GetConfigResponse>, req: GetConfigRequest): { promise: () => Promise<GetConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetConfigEndpoint),
      endpoint: GetConfigEndpoint
    };
  }

  export const UpsertConfigEndpoint = "/grpc/warehauser.WarehouseConfigService/UpsertConfig";
  /**
   * UpsertConfig upserts a warehouse configuration to the list of warehouse configurations for an org.
   * But each warehouse configuration is inserted or updated as a whole, i.e., no upsert at the field level.
   */
  export function UpsertConfig(sender: (req: UpsertConfigRequest, endpoint: string) => Promise<UpsertConfigResponse>, req: UpsertConfigRequest): { promise: () => Promise<UpsertConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpsertConfigEndpoint),
      endpoint: UpsertConfigEndpoint
    };
  }

  export const DeleteConfigEndpoint = "/grpc/warehauser.WarehouseConfigService/DeleteConfig";
  export function DeleteConfig(sender: (req: DeleteConfigRequest, endpoint: string) => Promise<{}>, req: DeleteConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteConfigEndpoint),
      endpoint: DeleteConfigEndpoint
    };
  }

  export const GetConfigOrgIdsEndpoint = "/grpc/warehauser.WarehouseConfigService/GetConfigOrgIds";
  /**
   * GetConfigOrgIds gets org ids according to the filters on the configured bronze warehouses. An example use case is
   * to exclude internal sync. The implementation is relatively expensive so caching is recommended.
   */
  export function GetConfigOrgIds(sender: (req: GetConfigOrgIdsRequest, endpoint: string) => Promise<GetConfigOrgIdsResponse>, req: GetConfigOrgIdsRequest): { promise: () => Promise<GetConfigOrgIdsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetConfigOrgIdsEndpoint),
      endpoint: GetConfigOrgIdsEndpoint
    };
  }

  export const GetWarehouseRulesEndpoint = "/grpc/warehauser.WarehouseConfigService/GetWarehouseRules";
  /** GetWarehouseRules returns org-level warehouse sync settings and preferences. */
  export function GetWarehouseRules(sender: (req: GetWarehouseRulesRequest, endpoint: string) => Promise<GetWarehouseRulesResponse>, req: GetWarehouseRulesRequest): { promise: () => Promise<GetWarehouseRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetWarehouseRulesEndpoint),
      endpoint: GetWarehouseRulesEndpoint
    };
  }

  export const SetWarehouseRulesEndpoint = "/grpc/warehauser.WarehouseConfigService/SetWarehouseRules";
  /** SetWarehouseRules sets org-level warehouse sync settings and preferences. */
  export function SetWarehouseRules(sender: (req: SetWarehouseRulesRequest, endpoint: string) => Promise<{}>, req: SetWarehouseRulesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetWarehouseRulesEndpoint),
      endpoint: SetWarehouseRulesEndpoint
    };
  }

  export const UpgradeSchemaVersionEndpoint = "/grpc/warehauser.WarehouseConfigService/UpgradeSchemaVersion";
  /**
   * UpgradeSchemaVersion will set the schema version for the warehouse configuration of an org.
   * It does not perform any migrations or schema changes directly, only updates the configuration.
   */
  export function UpgradeSchemaVersion(sender: (req: UpgradeSchemaVersionRequest, endpoint: string) => Promise<{}>, req: UpgradeSchemaVersionRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpgradeSchemaVersionEndpoint),
      endpoint: UpgradeSchemaVersionEndpoint
    };
  }

  export const SetConfigBundleFlowEndpoint = "/grpc/warehauser.WarehouseConfigService/SetConfigBundleFlow";
  /**
   * SetConfigBundleFlow sets the bundle flow for the warehouse configuration of an org. This endpoint only changes the
   * configuration and should be used with caution. Usually, the state of the previous bundle flow is manually cleaned
   * up and then the bundle flow is changed to a different one.
   */
  export function SetConfigBundleFlow(sender: (req: SetConfigBundleFlowRequest, endpoint: string) => Promise<{}>, req: SetConfigBundleFlowRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetConfigBundleFlowEndpoint),
      endpoint: SetConfigBundleFlowEndpoint
    };
  }

  export const RestoreConfigEndpoint = "/grpc/warehauser.WarehouseConfigService/RestoreConfig";
  /**
   * RestoreConfig is an internal only endpoint which enables restoring the warehouse configuration for an org to a
   * previous auditstore version.
   */
  export function RestoreConfig(sender: (req: RestoreConfigRequest, endpoint: string) => Promise<{}>, req: RestoreConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RestoreConfigEndpoint),
      endpoint: RestoreConfigEndpoint
    };
  }

  export const GetConfigBundleFlowEndpoint = "/grpc/warehauser.WarehouseConfigService/GetConfigBundleFlow";
  /** GetConfigBundleFlow returns the bronze bundle flows information for an org if the org has configurations. */
  export function GetConfigBundleFlow(sender: (req: GetConfigBundleFlowRequest, endpoint: string) => Promise<OrgConfigBundleFlow>, req: GetConfigBundleFlowRequest): { promise: () => Promise<OrgConfigBundleFlow>, endpoint: string } {
    return {
      promise: () => sender(req, GetConfigBundleFlowEndpoint),
      endpoint: GetConfigBundleFlowEndpoint
    };
  }

  export const GetAllConfigBundleFlowsEndpoint = "/grpc/warehauser.WarehouseConfigService/GetAllConfigBundleFlows";
  /** GetAllConfigBundleFlows returns the bronze bundle flows information for all the orgs that have configurations. */
  export function GetAllConfigBundleFlows(sender: (req: {}, endpoint: string) => Promise<GetAllConfigBundleFlowsResponse>, req: {}): { promise: () => Promise<GetAllConfigBundleFlowsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllConfigBundleFlowsEndpoint),
      endpoint: GetAllConfigBundleFlowsEndpoint
    };
  }

  export const SetSilverEnabledEndpoint = "/grpc/warehauser.WarehouseConfigService/SetSilverEnabled";
  /**
   * SetSilverEnabled will set the silver_enabled flag for the warehouse configuration of an org. If silver is enabled,
   * bundles will also flow to the internal Agnes warehouse. If silver is disabled, the traditional sync will be used.
   */
  export function SetSilverEnabled(sender: (req: SetSilverEnabledRequest, endpoint: string) => Promise<SetSilverEnabledResponse>, req: SetSilverEnabledRequest): { promise: () => Promise<SetSilverEnabledResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetSilverEnabledEndpoint),
      endpoint: SetSilverEnabledEndpoint
    };
  }

  export const SetBronzeDisabledEndpoint = "/grpc/warehauser.WarehouseConfigService/SetBronzeDisabled";
  /**
   * SetBronzeDisabled will set the bronze_disabled flag for the warehouse configuration of an org. If bronze is disabled,
   * bronze bundles will no longer flow to the customer's warehouses.
   */
  export function SetBronzeDisabled(sender: (req: SetBronzeDisabledRequest, endpoint: string) => Promise<SetBronzeDisabledResponse>, req: SetBronzeDisabledRequest): { promise: () => Promise<SetBronzeDisabledResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetBronzeDisabledEndpoint),
      endpoint: SetBronzeDisabledEndpoint
    };
  }
}

export namespace WarehouseStatusService {

  export const GetSyncStatusEndpoint = "/grpc/warehauser.WarehouseStatusService/GetSyncStatus";
  export function GetSyncStatus(sender: (req: GetSyncStatusRequest, endpoint: string) => Promise<GetSyncStatusResponse>, req: GetSyncStatusRequest): { promise: () => Promise<GetSyncStatusResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSyncStatusEndpoint),
      endpoint: GetSyncStatusEndpoint
    };
  }

  export const SetSyncStatusEndpoint = "/grpc/warehauser.WarehouseStatusService/SetSyncStatus";
  export function SetSyncStatus(sender: (req: SetSyncStatusRequest, endpoint: string) => Promise<{}>, req: SetSyncStatusRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetSyncStatusEndpoint),
      endpoint: SetSyncStatusEndpoint
    };
  }
}

export namespace WarehouseSettingsPublic {

  export const GetSyncSettingsEndpoint = "/grpc/warehauser.WarehouseSettingsPublic/GetSyncSettings";
  export function GetSyncSettings(sender: (req: {}, endpoint: string) => Promise<GetSyncSettingsResponse>, req: {}): { promise: () => Promise<GetSyncSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSyncSettingsEndpoint),
      endpoint: GetSyncSettingsEndpoint
    };
  }

  export const PutSyncSettingsEndpoint = "/grpc/warehauser.WarehouseSettingsPublic/PutSyncSettings";
  export function PutSyncSettings(sender: (req: PutSyncSettingsRequest, endpoint: string) => Promise<{}>, req: PutSyncSettingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, PutSyncSettingsEndpoint),
      endpoint: PutSyncSettingsEndpoint
    };
  }

  export const DeleteSyncSettingsEndpoint = "/grpc/warehauser.WarehouseSettingsPublic/DeleteSyncSettings";
  export function DeleteSyncSettings(sender: (req: DeleteSyncSettingsRequest, endpoint: string) => Promise<{}>, req: DeleteSyncSettingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSyncSettingsEndpoint),
      endpoint: DeleteSyncSettingsEndpoint
    };
  }

  export const GetWarehouseRulesEndpoint = "/grpc/warehauser.WarehouseSettingsPublic/GetWarehouseRules";
  export function GetWarehouseRules(sender: (req: {}, endpoint: string) => Promise<GetWarehouseRulesResponse>, req: {}): { promise: () => Promise<GetWarehouseRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetWarehouseRulesEndpoint),
      endpoint: GetWarehouseRulesEndpoint
    };
  }

  export const PutWarehouseRulesEndpoint = "/grpc/warehauser.WarehouseSettingsPublic/PutWarehouseRules";
  export function PutWarehouseRules(sender: (req: PutWarehouseRulesRequest, endpoint: string) => Promise<{}>, req: PutWarehouseRulesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, PutWarehouseRulesEndpoint),
      endpoint: PutWarehouseRulesEndpoint
    };
  }
}

export namespace WarehouseManualFixService {

  export const ManualFixOrgEndpoint = "/grpc/warehauser.WarehouseManualFixService/ManualFixOrg";
  export function ManualFixOrg(sender: (req: ManualFixOrgRequest, endpoint: string) => Promise<{}>, req: ManualFixOrgRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ManualFixOrgEndpoint),
      endpoint: ManualFixOrgEndpoint
    };
  }

  export const ManualFixOrgsEndpoint = "/grpc/warehauser.WarehouseManualFixService/ManualFixOrgs";
  export function ManualFixOrgs(sender: (req: ManualFixOrgsRequest, endpoint: string) => Promise<{}>, req: ManualFixOrgsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ManualFixOrgsEndpoint),
      endpoint: ManualFixOrgsEndpoint
    };
  }
}

export namespace SnowflakeAdminService {

  export const GetSnowflakeQueryHistoryEndpoint = "/grpc/warehauser.SnowflakeAdminService/GetSnowflakeQueryHistory";
  export function GetSnowflakeQueryHistory(sender: (req: GetSnowflakeQueryHistoryRequest, endpoint: string) => Promise<GetSnowflakeQueryHistoryResponse>, req: GetSnowflakeQueryHistoryRequest): { promise: () => Promise<GetSnowflakeQueryHistoryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSnowflakeQueryHistoryEndpoint),
      endpoint: GetSnowflakeQueryHistoryEndpoint
    };
  }
}

export namespace SilverSyncAdminService {

  export const GetSilverExportWatermarkEndpoint = "/grpc/warehauser.SilverSyncAdminService/GetSilverExportWatermark";
  /** GetSilverExportWatermark gets the export watermark for a table for the silver sync. */
  export function GetSilverExportWatermark(sender: (req: GetSilverExportWatermarkRequest, endpoint: string) => Promise<GetSilverExportWatermarkResponse>, req: GetSilverExportWatermarkRequest): { promise: () => Promise<GetSilverExportWatermarkResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSilverExportWatermarkEndpoint),
      endpoint: GetSilverExportWatermarkEndpoint
    };
  }

  export const SetSilverExportWatermarkEndpoint = "/grpc/warehauser.SilverSyncAdminService/SetSilverExportWatermark";
  /** SetSilverExportWatermark sets the watermark for a table for the silver sync. */
  export function SetSilverExportWatermark(sender: (req: SetSilverExportWatermarkRequest, endpoint: string) => Promise<{}>, req: SetSilverExportWatermarkRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetSilverExportWatermarkEndpoint),
      endpoint: SetSilverExportWatermarkEndpoint
    };
  }
}

export interface GetSilverExportWatermarkRequest {
  orgId: string;
  projectName: string;
  datasetName: string;
  tableName: string;
}

export interface GetSilverExportWatermarkResponse {
  watermark: protobuf.timestamp | null;
}

export interface SetSilverExportWatermarkRequest {
  orgId: string;
  projectName: string;
  datasetName: string;
  tableName: string;
  watermark: protobuf.timestamp | null;
}

export interface MigrateCronsToCloudRequest {
  /**
   * If true, the crons will be migrated to the cloud and the hosted crons will be stopped.
   * If false, the crons will be migrated from the cloud and the hosted crons will be started.
   */
  up: boolean;
  /** If true, actually perform the migration. If false, just return the migration plan without performing it. */
  notDryRun: boolean;
}

export interface MigrateCronsToCloudResponse {
  /** The list of org IDs that were migrated. */
  orgIds: string[];
  errorMessage: string;
}

/** WarehouseSyncStatus represents the sync status for an org that is user-facing. */
export enum WarehouseSyncStatus {
  WAREHOUSE_SYNC_STATUS_INVALID = 0,
  WAREHOUSE_SYNC_STATUS_ACTIVE = 1,
  WAREHOUSE_SYNC_STATUS_INACTIVE = 2,
  WAREHOUSE_SYNC_STATUS_AUTH_ERROR = 3
}

/**
 * WarehauserSyncStatus represents the last internal sync status for an org that is not user-facing.
 * This enum is persisted as int values, so do not change the int values of this enum.
 */
export enum WarehauserSyncStatus {
  WAREHAUSER_SYNC_STATUS_INVALID = 0,
  /** the last sync status is unknown because the sync settings was deleted by the user. */
  WAREHAUSER_SYNC_STATUS_UNKNOWN = 1,
  /** the last sync is ok, a bundle was synced successfully. */
  WAREHAUSER_SYNC_STATUS_SYNC_OK = 2,
  /** the sync settings pass validation, but there has not been an actual bundle synced yet. */
  WAREHAUSER_SYNC_STATUS_AUTH_OK = 3,
  /** the sync settings are missing while there are bundles to be synced. */
  WAREHAUSER_SYNC_STATUS_AUTH_MISSING = 4,
  /** the sync settings are not correct, including both authentication and authorization errors. */
  WAREHAUSER_SYNC_STATUS_AUTH_ERROR = 5,
  /** the last sync was not successful and it is noteworthy to users; this status could be set via admin ui. */
  WAREHAUSER_SYNC_STATUS_USER_ERROR = 6,
  /** the last sync was not successful because of generic errors that are not noteworthy to users. */
  WAREHAUSER_SYNC_STATUS_SYNC_ERROR = 7,
  /** the last sync did not have bundle, which is ok; can also manually set to snooze monitoring alerts. */
  WAREHAUSER_SYNC_STATUS_SYNC_EMPTY = 8
}

/** OrgWarehouseSyncStatus represents the sync statuses for an org that support monitoring and alerting. */
export interface OrgWarehouseSyncStatus {
  orgId: string;
  /** WarehouseStatuses should be a map but protobuf cannot use enum as the key. */
  warehouseStatuses: OrgWarehouseSyncStatus.ByWarehouse[];
}

/** OrgWarehouseSyncStatus represents the sync statuses for an org that support monitoring and alerting. */
export namespace OrgWarehouseSyncStatus {
  /** OrgWarehouseSyncStatus_ByWarehouse represents the sync status of a warehouse for an org. */
  export interface ByWarehouse {
    provider: WarehouseProvider;
    /**
     * SettingsStatus maps to the status in the settings ui that is shown to the users. For now, it is derived from the
     * sync status for the EVENTS kind only (because of historical reasons).
     */
    settingsStatus: WarehauserSyncStatus;
    /** LastTasksDrained is the last timestamp when all the tasks for the warehouse were drained. */
    lastTasksDrained: protobuf.timestamp | null;
    /** LastAuthSuccess is the last timestamp when the sync status was AUTH_OK, e.g., after settings are saved. */
    lastAuthSuccess: protobuf.timestamp | null;
    /** AutomaticSnoozeSince is the timestamp that the automatic snooze started because of user errors. */
    automaticSnoozeSince: protobuf.timestamp | null;
    /** ManualSnoozeUntil is the timestamp that the manual snooze will end. */
    manualSnoozeUntil: protobuf.timestamp | null;
    /** KindStatuses should be a map but protobuf cannot use enum as the key. */
    kindStatuses: OrgWarehouseSyncStatus.ByKind[];
  }

  /** OrgWarehouseSyncStatus_ByKind represents the sync status of a kind in a warehouse for an org. */
  export interface ByKind {
    kind: WarehouseSyncKind;
    /** LastSyncSuccess is the last timestamp when the sync status was SYNC_OK. */
    lastSyncSuccess: protobuf.timestamp | null;
    /** Status is the last known sync status of the kind. */
    status: WarehauserSyncStatus;
    /** Details is usually the error string for a failure status; empty for a success status. */
    details: string;
    /** Message is usually the user facing error message for a failure status that can be localized; empty for a success status. */
    message: string;
    /** LastSyncEmpty is the last timestamp when the workflow is running normally but no bundle needs to be synced. */
    lastSyncEmpty: protobuf.timestamp | null;
  }
}

export interface GetSyncStatusRequest {
  orgId: string;
}

export interface GetSyncStatusResponse {
  status: OrgWarehouseSyncStatus | null;
}

export interface SetSyncStatusRequest {
  orgId: string;
  provider: WarehouseProvider;
  /** sets the status that all the tasks for the warehouse have been drained at the current timestamp. */
  setTasksDrainedOperation?: SetSyncStatusRequest.SetTasksDrained | null;
  /** sets the status that authentication was successful for the warehouse at the current timestamp. */
  setAuthSuccessOperation?: SetSyncStatusRequest.SetAuthSuccess | null;
  /** sets the status of the last handled task of a kind for the warehouse at the current timestamp. */
  setTaskStatusOperation?: SetSyncStatusRequest.SetTaskStatus | null;
}

export namespace SetSyncStatusRequest {
  export interface SetTasksDrained {
  }

  export interface SetAuthSuccess {
  }

  export interface SetTaskStatus {
    kind: WarehouseSyncKind;
    status: WarehauserSyncStatus;
    /** optional details like stack traces; only needed for error statuses. */
    details: string;
    /** optional user facing message that can be localized. only needed for error statuses. */
    message: string;
  }

  export enum operation {
    /** sets the status that all the tasks for the warehouse have been drained at the current timestamp. */
    setTasksDrainedOperation = 3,
    /** sets the status that authentication was successful for the warehouse at the current timestamp. */
    setAuthSuccessOperation = 4,
    /** sets the status of the last handled task of a kind for the warehouse at the current timestamp. */
    setTaskStatusOperation = 5
  }

  export function operation_oneof(m: SetSyncStatusRequest): { opt: operation.setAuthSuccessOperation, val: SetSyncStatusRequest.SetAuthSuccess } | { opt: operation.setTaskStatusOperation, val: SetSyncStatusRequest.SetTaskStatus } | { opt: operation.setTasksDrainedOperation, val: SetSyncStatusRequest.SetTasksDrained } | null {
    if (m.setTasksDrainedOperation != null) { return { opt: operation.setTasksDrainedOperation, val: m.setTasksDrainedOperation } }
    if (m.setAuthSuccessOperation != null) { return { opt: operation.setAuthSuccessOperation, val: m.setAuthSuccessOperation } }
    if (m.setTaskStatusOperation != null) { return { opt: operation.setTaskStatusOperation, val: m.setTaskStatusOperation } }
    return null;
  }
}

export interface SnowflakeSyncSettings {
  account: string;
  user: string;
  password?: string;
  privateKey?: string;
  database: string;
  warehouse: string;
  role: string;
  storageIntegration: string;
  schema: string;
}

export namespace SnowflakeSyncSettings {
  export enum secret {
    password = 3,
    privateKey = 9
  }

  export function secret_oneof(m: SnowflakeSyncSettings): { opt: secret.password, val: string } | { opt: secret.privateKey, val: string } | null {
    if (m.password != null) { return { opt: secret.password, val: m.password } }
    if (m.privateKey != null) { return { opt: secret.privateKey, val: m.privateKey } }
    return null;
  }
}

export interface BigQuerySyncSettings {
  serviceAccountKey: string;
  project: string;
  dataset: string;
}

export interface RedshiftSyncSettings {
  iamArn: string;
  bucket: string;
  region: string;
  host: string;
  port: number;
  schema: string;
  database: string;
  serverlessConnector?: RedshiftSyncSettings.Serverless | null;
  provisionedConnector?: RedshiftSyncSettings.Provisioned | null;
  sessionName: string;
}

export namespace RedshiftSyncSettings {
  export enum connector {
    serverlessConnector = 8,
    provisionedConnector = 9
  }

  export function connector_oneof(m: RedshiftSyncSettings): { opt: connector.provisionedConnector, val: RedshiftSyncSettings.Provisioned } | { opt: connector.serverlessConnector, val: RedshiftSyncSettings.Serverless } | null {
    if (m.serverlessConnector != null) { return { opt: connector.serverlessConnector, val: m.serverlessConnector } }
    if (m.provisionedConnector != null) { return { opt: connector.provisionedConnector, val: m.provisionedConnector } }
    return null;
  }

  export interface Serverless {
    workgroup: string;
  }

  export interface Provisioned {
    clusterIdentifier: string;
  }
}

export interface S3SyncSettings {
  bucket: string;
  keyPrefix: string;
  iamArn: string;
  region: string;
  sessionName: string;
}

export interface GCSSyncSettings {
  serviceAccountKey: string;
  bucket: string;
  objectPrefix: string;
}

export interface BlobStorageSyncSettings {
  tenantId: string;
  clientId: string;
  storageAccountUrl: string;
  containerPath: string;
}

export interface WarehouseSyncSettings {
  status: WarehouseSyncStatus;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
  snowflake?: SnowflakeSyncSettings | null;
  bigQuery?: BigQuerySyncSettings | null;
  redshift?: RedshiftSyncSettings | null;
  s3?: S3SyncSettings | null;
  gcs?: GCSSyncSettings | null;
  blobStorage?: BlobStorageSyncSettings | null;
}

export namespace WarehouseSyncSettings {
  export enum settings {
    snowflake = 2,
    bigQuery = 3,
    redshift = 4,
    s3 = 7,
    gcs = 8,
    blobStorage = 9
  }

  export function settings_oneof(m: WarehouseSyncSettings): { opt: settings.bigQuery, val: BigQuerySyncSettings } | { opt: settings.blobStorage, val: BlobStorageSyncSettings } | { opt: settings.gcs, val: GCSSyncSettings } | { opt: settings.redshift, val: RedshiftSyncSettings } | { opt: settings.s3, val: S3SyncSettings } | { opt: settings.snowflake, val: SnowflakeSyncSettings } | null {
    if (m.snowflake != null) { return { opt: settings.snowflake, val: m.snowflake } }
    if (m.bigQuery != null) { return { opt: settings.bigQuery, val: m.bigQuery } }
    if (m.redshift != null) { return { opt: settings.redshift, val: m.redshift } }
    if (m.s3 != null) { return { opt: settings.s3, val: m.s3 } }
    if (m.gcs != null) { return { opt: settings.gcs, val: m.gcs } }
    if (m.blobStorage != null) { return { opt: settings.blobStorage, val: m.blobStorage } }
    return null;
  }
}

export interface GetSyncSettingsResponse {
  settings: WarehouseSyncSettings[];
}

export interface PutSyncSettingsRequest {
  snowflake?: SnowflakeSyncSettings | null;
  bigQuery?: BigQuerySyncSettings | null;
  redshift?: RedshiftSyncSettings | null;
  s3?: S3SyncSettings | null;
  gcs?: GCSSyncSettings | null;
  blobStorage?: BlobStorageSyncSettings | null;
}

export namespace PutSyncSettingsRequest {
  export enum settings {
    snowflake = 1,
    bigQuery = 2,
    redshift = 3,
    s3 = 4,
    gcs = 5,
    blobStorage = 6
  }

  export function settings_oneof(m: PutSyncSettingsRequest): { opt: settings.bigQuery, val: BigQuerySyncSettings } | { opt: settings.blobStorage, val: BlobStorageSyncSettings } | { opt: settings.gcs, val: GCSSyncSettings } | { opt: settings.redshift, val: RedshiftSyncSettings } | { opt: settings.s3, val: S3SyncSettings } | { opt: settings.snowflake, val: SnowflakeSyncSettings } | null {
    if (m.snowflake != null) { return { opt: settings.snowflake, val: m.snowflake } }
    if (m.bigQuery != null) { return { opt: settings.bigQuery, val: m.bigQuery } }
    if (m.redshift != null) { return { opt: settings.redshift, val: m.redshift } }
    if (m.s3 != null) { return { opt: settings.s3, val: m.s3 } }
    if (m.gcs != null) { return { opt: settings.gcs, val: m.gcs } }
    if (m.blobStorage != null) { return { opt: settings.blobStorage, val: m.blobStorage } }
    return null;
  }
}

/** This enum is persisted as int values, so do not change the int values of this enum. */
export enum WarehouseProvider {
  /**
   * WarehouseProvider_WAREHOUSE_PROVIDER_INVALID means no provider specified and applies to all public providers
   * (see IsWarehouseProviderPublic) when used as a filter.
   */
  WAREHOUSE_PROVIDER_INVALID = 0,
  WAREHOUSE_PROVIDER_SNOWFLAKE = 1,
  WAREHOUSE_PROVIDER_BIG_QUERY = 2,
  WAREHOUSE_PROVIDER_INTERNAL = 3,
  WAREHOUSE_PROVIDER_REDSHIFT = 4,
  WAREHOUSE_PROVIDER_S3 = 5,
  WAREHOUSE_PROVIDER_GCS = 6,
  WAREHOUSE_PROVIDER_BLOB_STORAGE = 7,
  /** The synthetic provider that ingests bronze data for silver transformation. */
  WAREHOUSE_PROVIDER_AGNES = 8
}

export interface DeleteSyncSettingsRequest {
  provider: WarehouseProvider;
}

export interface WarehouseConfigs {
  configs: WarehouseConfig[];
  cronIntervalMinutes: number;
}

export interface WarehouseConfig {
  bigQuery?: WarehouseConfig.BigQueryConfig | null;
  snowflake?: WarehouseConfig.SnowflakeConfig | null;
  /** uses the cog service account to sync to the predefined internal destination. */
  internal?: WarehouseConfig.InternalConfig | null;
  redshift?: RedshiftConfig | null;
  s3?: WarehouseConfig.S3Config | null;
  gcs?: WarehouseConfig.GCSConfig | null;
  blobStorage?: WarehouseConfig.BlobStorageConfig | null;
  /** do not specify when upserting a configuration; will be set automatically. */
  updatedAt: protobuf.timestamp | null;
  /** do not specify when upserting a configuration; will be set automatically. */
  updatedBy: string;
  /**
   * Whether or not we will sync to to our internal BigQuery so that silver transformations
   * can happen via Agnes.
   */
  silverEnabled: boolean;
  /** Whether or not we should skip the traditional bronze sync and only sync silver tables. */
  bronzeDisabled: boolean;
}

export namespace WarehouseConfig {
  export interface BigQueryConfig {
    projectId: string;
    dataset: string;
    credentials: string;
    schemaVersion: number;
    /**
     * The bundle flow for this warehouse which determines what tasks to be accepted by this warehouse. Since it is not
     * trivial and automatic to switch between bundle flows, this field is ignored when updating a configuration.
     */
    bundleFlow: WarehauserBundleFlow;
  }

  export interface SnowflakeConfig {
    account: string;
    user: string;
    password?: string;
    privateKey?: string;
    database: string;
    warehouse: string;
    role: string;
    storageIntegration: string;
    serviceAccount: string;
    schema: string;
    /**
     * The bundle flow for this warehouse which determines what tasks to be accepted by this warehouse. Since it is not
     * trivial and automatic to switch between bundle flows, this field is ignored when updating a configuration.
     */
    bundleFlow: WarehauserBundleFlow;
  }

  export namespace SnowflakeConfig {
    export enum secret {
      password = 3,
      privateKey = 11
    }

    export function secret_oneof(m: SnowflakeConfig): { opt: secret.password, val: string } | { opt: secret.privateKey, val: string } | null {
      if (m.password != null) { return { opt: secret.password, val: m.password } }
      if (m.privateKey != null) { return { opt: secret.privateKey, val: m.privateKey } }
      return null;
    }
  }

  export interface InternalConfig {
    schemaVersion: number;
    /**
     * an org with event stream, aka live sync, disabled can still sync via, e.g., backfill.
     * note that this only affects bronze; silver, if enabled, always has live sync.
     */
    disableEventStream: boolean;
  }

  export interface S3Config {
    /** The name of the bucket to sync the bundle files to. */
    bucket: string;
    /** The optional prefix added to each key when syncing bundle files to the bucket. */
    keyPrefix: string;
    /** The iam role arn for the S3 connection. */
    iamArn: string;
    /** The region for the connection. */
    region: string;
    /** The optional session name for authentication audit purposes. */
    sessionName: string;
  }

  export interface GCSConfig {
    /** The name of the bucket to sync the bundle files to. */
    bucket: string;
    /** The optional prefix added to each object when syncing bundle files to the bucket. */
    objectPrefix: string;
    /** The credentials for the GCS connection, usually the json of a service account key. */
    credentials: string;
  }

  export interface BlobStorageConfig {
    /** The tenant id for the blob storage connection located in the Entra ID section of the Azure Portal. */
    tenantId: string;
    /** THe Microsoft.ManagedIdentity client id for the blob storage connection. */
    clientId: string;
    /** The URL for the Azure storage account. */
    storageAccountUrl: string;
    /** The container path for the blob storage connection. */
    containerPath: string;
  }

  export enum destination {
    bigQuery = 1,
    snowflake = 2,
    /** uses the cog service account to sync to the predefined internal destination. */
    internal = 3,
    redshift = 4,
    s3 = 7,
    gcs = 8,
    blobStorage = 9
  }

  export function destination_oneof(m: WarehouseConfig): { opt: destination.bigQuery, val: WarehouseConfig.BigQueryConfig } | { opt: destination.blobStorage, val: WarehouseConfig.BlobStorageConfig } | { opt: destination.gcs, val: WarehouseConfig.GCSConfig } | { opt: destination.internal, val: WarehouseConfig.InternalConfig } | { opt: destination.redshift, val: RedshiftConfig } | { opt: destination.s3, val: WarehouseConfig.S3Config } | { opt: destination.snowflake, val: WarehouseConfig.SnowflakeConfig } | null {
    if (m.bigQuery != null) { return { opt: destination.bigQuery, val: m.bigQuery } }
    if (m.snowflake != null) { return { opt: destination.snowflake, val: m.snowflake } }
    if (m.internal != null) { return { opt: destination.internal, val: m.internal } }
    if (m.redshift != null) { return { opt: destination.redshift, val: m.redshift } }
    if (m.s3 != null) { return { opt: destination.s3, val: m.s3 } }
    if (m.gcs != null) { return { opt: destination.gcs, val: m.gcs } }
    if (m.blobStorage != null) { return { opt: destination.blobStorage, val: m.blobStorage } }
    return null;
  }
}

export interface RedshiftConfig {
  /**
   * the iam role arn to use when connecting to AWS
   * this role should have all of the permissions necessary
   * to operate the redshift integration (including S3 read/write)
   */
  iamArn: string;
  /** the name of the bucket to use for staging the data files */
  bucket: string;
  /** the region to use when connecting to the AWS API */
  region: string;
  /** the host to use when connecting to the AWS Redshift */
  host: string;
  /** the port to use when connecting to the AWS Redshift */
  port: number;
  /**
   * the schema to use when connecting to the AWS Redshift. Optional: When not supplied FullStory will create a schema
   * Some customer has restrictions on how the schema should be named. The customer is responsible to make sure different orgs do not
   * use the same tables. If schema is not supplied the user created dynamically using the IAM role must have permissions
   * to create schema on the instance
   */
  schema: string;
  /** the database to use when connecting to the AWS Redshift */
  database: string;
  serverlessConnector?: RedshiftConfig.Serverless | null;
  provisionedConnector?: RedshiftConfig.Provisioned | null;
  /** the session name that is sent to AWS IAM for authentication audit purposes */
  sessionName: string;
  /** the schema version to use when loading the data into the warehouse */
  schemaVersion: number;
  /**
   * The bundle flow for this warehouse which determines what tasks to be accepted by this warehouse. Since it is not
   * trivial and automatic to switch between bundle flows, this field is ignored when updating a configuration.
   */
  bundleFlow: WarehauserBundleFlow;
}

export namespace RedshiftConfig {
  /** properties for Redshift Serverless or Redshift Provisioned Cluster */
  export enum connector {
    serverlessConnector = 8,
    provisionedConnector = 9
  }

  /** properties for Redshift Serverless or Redshift Provisioned Cluster */
  export function connector_oneof(m: RedshiftConfig): { opt: connector.provisionedConnector, val: RedshiftConfig.Provisioned } | { opt: connector.serverlessConnector, val: RedshiftConfig.Serverless } | null {
    if (m.serverlessConnector != null) { return { opt: connector.serverlessConnector, val: m.serverlessConnector } }
    if (m.provisionedConnector != null) { return { opt: connector.provisionedConnector, val: m.provisionedConnector } }
    return null;
  }

  export interface Serverless {
    /** the workgroup to use when connecting to the AWS Redshift Serverless */
    workgroup: string;
  }

  export interface Provisioned {
    /** the cluster_identifier to use when connecting to the AWS Redshift Provisioned Cluster */
    clusterIdentifier: string;
  }
}

export interface DeleteConfigRequest {
  orgId: string;
  provider: WarehouseProvider;
}

export interface UpsertConfigRequest {
  orgId: string;
  config: WarehouseConfig | null;
  maxConfigs: number;
}

export interface UpsertConfigResponse {
  /** true if the config was inserted; false if the config was updated. */
  inserted: boolean;
}

export interface UpgradeSchemaVersionRequest {
  orgId: string;
  provider: WarehouseProvider;
  schemaVersion: number;
}

export interface SetConfigBundleFlowRequest {
  orgId: string;
  provider: WarehouseProvider;
  bundleFlow: WarehauserBundleFlow;
}

export interface GetConfigBundleFlowRequest {
  orgId: string;
}

export interface OrgConfigBundleFlow {
  orgId: string;
  internalSummary: OrgConfigBundleFlow.Summary | null;
  nonInternalSummary: OrgConfigBundleFlow.Summary | null;
}

export namespace OrgConfigBundleFlow {
  export interface Summary {
    configuredBundleFlows: WarehauserBundleFlow[];
    liveSyncEnabled: boolean;
  }
}

export interface GetAllConfigBundleFlowsResponse {
  orgConfigBundleFlows: OrgConfigBundleFlow[];
}

export interface RestoreConfigRequest {
  orgId: string;
  /** The auditstore key name. */
  auditStoreId: protobuf.int64;
}

export interface GetConfigRequest {
  orgId: string;
}

export interface GetConfigResponse {
  configs: WarehouseConfigs | null;
}

export interface GetConfigOrgIdsRequest {
  /**
   * include an org in the response if the org has any of the listed warehouse configured;
   * an empty list means all orgs will be included.
   */
  includeAnyOf: WarehouseProvider[];
  /**
   * exclude an org in the response if the org has any of the listed warehouse configured;
   * an empty list means no orgs will be excluded.
   */
  excludeAnyOf: WarehouseProvider[];
  /**
   * include an org in the response if the org has any of the listed bundle flows configured;
   * an empty list means all orgs will be included
   */
  includeAnyOfBundleFlows: WarehauserBundleFlow[];
  /**
   * exclude an org in the response if the org has any of the listed bundle flows configured;
   * an empty list means no orgs will be excluded.
   */
  excludeAnyOfBundleFlows: WarehauserBundleFlow[];
}

export interface GetConfigOrgIdsResponse {
  orgIds: string[];
}

export interface GetDxoPrepStatusRequest {
  orgId: string;
}

export interface GetDxoPrepStatusResponse {
  orgId: string;
  statuses: GetDxoPrepStatusResponse.KindStatus[];
}

export namespace GetDxoPrepStatusResponse {
  export interface KindStatus {
    kind: WarehouseSyncKind;
    lastPrep: protobuf.timestamp | null;
  }
}

export interface SetDxoPrepStatusRequest {
  orgId: string;
  /** reset the last prep timestamp for named elements so that the next prep will include all named elements. */
  resetElementsLastPrep: boolean;
  /** reset the last prep timestamp for defined events so that the next prep will include all defined events. */
  resetEventsLastPrep: boolean;
  /** reset the last prep timestamp for defined pages so that the next prep will include all defined pages. */
  resetPagesLastPrep: boolean;
}

export interface SetInternalSyncRequest {
  orgId: string;
  enableInternalSync: boolean | null;
  /**
   * with event stream, aka live sync, disabled, there will be no hourly bundle, but can still sync via, e.g., backfill.
   * note that this only affects bronze; silver, if enabled, always has live sync.
   */
  disableEventStream: boolean;
}

export interface GetAllInternalSyncsResponse {
  internalSyncs: GetAllInternalSyncsResponse.InternalSync[];
}

export namespace GetAllInternalSyncsResponse {
  export interface InternalSync {
    orgId: string;
    schemaVersion: number;
    eventStreamDisabled: boolean;
  }
}

export interface InitializeObjectStorageHistoricalSyncRequest {
  orgId: string;
  /**
   * The historical sync start will be set to the analytics retention start if this field is zero value.
   * Otherwise the historical sync start will be set to this field.
   */
  overrideSyncStart: protobuf.timestamp | null;
}

export interface GetObjectStoragePrepStatusRequest {
  orgId: string;
}

export interface GetObjectStoragePrepStatusResponse {
  live: GetObjectStoragePrepStatusResponse.Watermarks | null;
  historical: GetObjectStoragePrepStatusResponse.Watermarks | null;
  historicalInitialized: boolean;
  /** The progress percentage in [0,1] for the historical bundle prep only (does not include bundle creation and sync). */
  historicalProgressPercentage: number;
}

export namespace GetObjectStoragePrepStatusResponse {
  export interface Watermarks {
    initialBundleWatermark: string;
    bundleWatermark: string;
    pageWatermark: string;
    taskWatermark: string;
  }
}

export interface GetObjectStorageBundlePagesRequest {
  orgId: string;
  bundleId: string;
}

export interface GetObjectStorageBundlePagesResponse {
  pageCount: number;
  pageArgs: schema.PageArgsProto[];
}

export interface GetObjectStoragePageBundleResponse {
  bundleId: string;
}

export interface WarehouseRules {
  isDxoSyncDisabled: boolean;
}

export interface GetWarehouseRulesRequest {
  orgId: string;
}

export interface GetWarehouseRulesResponse {
  warehouseRules: WarehouseRules | null;
}

export interface SetWarehouseRulesRequest {
  orgId: string;
  warehouseRules: WarehouseRules | null;
}

export interface PutWarehouseRulesRequest {
  warehouseRules: WarehouseRules | null;
}

export interface TriggerBackfillWorkflowRequest {
  orgId: string;
}

export interface WarehouseEvent {
  eventId: string;
  eventTime: protobuf.timestamp | null;
  processedTime: protobuf.timestamp | null;
  operation: radia.EventAndMetadata.Operation;
  deviceId: protobuf.int64;
  sessionId: protobuf.int64 | null;
  viewId: protobuf.int64 | null;
  eventType: string;
  /** this details object has to be marshaled as json string to walk around big query loading issue. */
  eventDetails: string;
  sourceType: string;
  /** this details object has to be marshaled as json string to walk around big query loading issue. */
  sourceDetails: string;
}

export interface WarehouseStatementEventLog {
  timestamp: protobuf.timestamp | null;
  orgId: string;
  warehouseType: string;
  workflow: string;
  statementType: string;
  waitMilliseconds: protobuf.int64;
  runMilliseconds: protobuf.int64;
  inputBytes: protobuf.int64;
  processedBytes: protobuf.int64;
  insertedRows: protobuf.int64;
  deletedRows: protobuf.int64;
  updatedRows: protobuf.int64;
  affectedRows: protobuf.int64;
  bundlePaths: string[];
}

/**
 * WarehouseJob represents a job created on a warehouse that may be running or has finished. It should have enough
 * information to wait for the job to finish and get results. This struct is expected to persisted in Temporal state.
 */
export interface WarehouseJob {
  orgId: string;
  provider: WarehouseProvider;
  /** The identifier of the job on the warehouse; Can be empty to indicate this job is not needed for the warehouse. */
  jobId: string;
  /** The type discriminator so that the particular warehouse provider knows how to parse the result, e.g., COPY. */
  resultType: string;
  /** The semantic label to indicate the purpose of the job, e.g., EVENTS_STAGE_LOAD. */
  label: string;
  createTime: protobuf.timestamp | null;
  /** Data that is needed for implementing warehouses. e.g. BigQuery job location */
  metadata: { [key: string]: string };
}

export interface GetSyncTaskRequest {
  orgId: string;
  taskId: string;
  /**
   * If provided, limits the returned warehouse tasks to the specified warehouses.
   * By default, all child tasks are returned.
   */
  providers: WarehouseProvider[];
}

export interface GetSyncTaskResponse {
  orgTask: WarehouseBundleSyncTask | null;
  warehouseTasks: WarehouseBundleSyncTask[];
}

export interface StartSyncRequest {
  orgId: string;
}

export enum WarehouseSyncPhase {
  WAREHOUSE_SYNC_PHASE_INVALID = 0,
  WAREHOUSE_SYNC_PHASE_PREP = 1,
  WAREHOUSE_SYNC_PHASE_SYNC = 2
}

export interface TriggerSyncRequest {
  orgId: string;
  phase: WarehouseSyncPhase;
}

export interface TriggerTransformRequest {
  orgId: string;
  isFullRefresh: boolean;
}

export interface StopSyncRequest {
  orgId: string;
}

export interface SetSyncIntervalRequest {
  orgId: string;
  /** The sync cron will run every x minutes, where x is a number in [1,60] that is also a factor of 60. Omit to use the default value. */
  cronIntervalMinutes: number;
}

export enum WarehouseSyncKind {
  WAREHOUSE_SYNC_KIND_INVALID = 0,
  WAREHOUSE_SYNC_KIND_EVENTS = 1,
  WAREHOUSE_SYNC_KIND_DX_NAMED_ELEMENTS = 2,
  WAREHOUSE_SYNC_KIND_DX_DEFINED_EVENTS = 3,
  WAREHOUSE_SYNC_KIND_DX_PAGES = 4
}

export enum WarehouseSyncMode {
  WAREHOUSE_SYNC_MODE_INVALID = 0,
  /** INCREMENTAL is the hourly sync for the merge based strategy (mutable, lower latency, can deduplicate, higher cost). */
  WAREHOUSE_SYNC_MODE_INCREMENTAL = 1,
  /** FULL is the backfill for the merge based strategy (mutable, lower latency, can deduplicate, higher cost). */
  WAREHOUSE_SYNC_MODE_FULL = 2,
  /** APPEND is the hourly sync for the append only strategy (immutable, higher latency, cannot deduplicate, lower cost). */
  WAREHOUSE_SYNC_MODE_APPEND = 3,
  /** REPLACE is the backfill for the append only strategy (immutable, higher latency, cannot deduplicate, lower cost). */
  WAREHOUSE_SYNC_MODE_REPLACE = 4,
  /**
   * REAPPEND is the backfill for the append only strategy that will delete the whole event time range first, and is
   * more efficient than REPLACE where multiple deletes are used (each delete is limited to the scope of a sync task).
   */
  WAREHOUSE_SYNC_MODE_REAPPEND = 5,
  /** SILVER indicates that the task is for syncing silver schema after transformation. */
  WAREHOUSE_SYNC_MODE_SILVER = 6
}

/**
 * SilverSync contains data needed to sync transformed silver bundles
 * to the customer's warehouses.
 */
export interface SilverSync {
  /** The path in GCS to the metadata file for this task. */
  metadataPath: string;
  /** The id of the agnes run that produced these bundle files. */
  runId: string;
}

/** BundleSyncSignalChannel represents the type of sync signals. */
export enum BundleSyncSignalChannel {
  BUNDLE_SYNC_SIGNAL_CHANNEL_INVALID = 0,
  /** The bundle represented by the signal recipient has been created and put into the sync queue. */
  BUNDLE_SYNC_SIGNAL_CHANNEL_SCHEDULED = 1,
  /** The bundle represented by the signal recipient has been dispatched to warehouses based on configuration. */
  BUNDLE_SYNC_SIGNAL_CHANNEL_DISPATCHED = 2,
  /** The bundle represented by the signal recipient has been synced in one of the dispatched warehouses. */
  BUNDLE_SYNC_SIGNAL_CHANNEL_SYNCED = 3,
  /** The bundle represented by the signal recipient has been created and is not meant for syncing. */
  BUNDLE_SYNC_SIGNAL_CHANNEL_BUNDLED = 4
}

/** BundleSyncSignalRecipient represents the recipient to receive sync signals, which is currently a Temporal workflow. */
export interface BundleSyncSignalRecipient {
  /**
   * The id of the recipient which is some identifier in the running Temporal workflow so that the workflow knows how
   * to process a signal. For example, in a backfill workflow, this identifier can be the watermark of a bundle.
   */
  id: string;
  /** The workflow id of the running Temporal workflow. */
  workflowId: string;
  /** The run id of the running Temporal workflow. */
  runId: string;
}

/** BundleSyncSignalBody represents the body of a sync signal. Fields are available depending on the signal channel. */
export interface BundleSyncSignalBody {
  recipient: string;
  dispatched: WarehouseProvider[];
  synced: WarehouseProvider;
}

export interface BundleNotificationRequest {
  signalRecipient: BundleSyncSignalRecipient | null;
}

/** WarehouseBundleSyncTask represents a persisted task of syncing a GCS bundle to warehouses. */
export interface WarehouseBundleSyncTask {
  /** The org id of the bundle which must match the path. */
  orgId: string;
  /**
   * The task id of the bundle, which will be derived from the path if not specified. Tasks with the same org_id and
   * kind are sorted by task id lexicographically.
   */
  taskId: string;
  /** The kind of the bundle which must match the path. */
  kind: WarehouseSyncKind;
  /** The mode to sync the bundle. */
  mode: WarehouseSyncMode;
  /**
   * The only warehouse to sync the task to. Usually only specified when repairing a particular warehouse. Normally,
   * this field should not be specified, so that the task will be synced to all the configured warehouses except
   * INTERNAL. If the specified warehouse is not one of the configured warehouses, the task will be ignored.
   */
  provider: WarehouseProvider;
  /**
   * The timestamp when the task was created. It implies that the bundle in the task was created before this timestamp.
   * Treat the timestamp as metadata managed by the task store and do not set it manually.
   */
  created: protobuf.timestamp | null;
  /** The bundle flow that created the path, such as IMMUTABLE and OBJECT_STORAGE. */
  flow: WarehauserBundleFlow;
  /** The GCS paths of the bundles. The directories must conventionally match the org id and kind. Can be empty. */
  paths: string[];
  /** The time range to delete before syncing the paths. */
  preDelete: WarehouseBundleSyncTask.PreDeleteTimeRange | null;
  /** Sync the silver schema such as copying after transformation. If this is not set, the task is meant for bronze. */
  silver: SilverSync | null;
  /** If set, sync signals will be sent to the recipient. Usually used to notify a waiting workflow. */
  signalRecipient: BundleSyncSignalRecipient | null;
}

/** WarehouseBundleSyncTask represents a persisted task of syncing a GCS bundle to warehouses. */
export namespace WarehouseBundleSyncTask {
  export interface PreDeleteTimeRange {
    start: protobuf.timestamp | null;
    end: protobuf.timestamp | null;
  }
}

export interface WorkflowExecutionInfo {
  /** Temporal Workflow ID for the associated workflow. */
  workflowId: string;
  /** Temporal Run ID for the associated workflow. */
  runId: string;
}

export interface PutSyncTaskRequest {
  /** The org id of the task which must match the path, if path is provided. */
  orgId: string;
  /**
   * The timestamp of the task which determines the sort order. Use a way earlier timestamp to put the task at the top
   * of all the tasks. If timestamp is not provided, now will be used as the timestamp.
   */
  timestamp: protobuf.timestamp | null;
  /**
   * The GCS bundle paths of the task. The directories must conventionally match the org id and the kind. If no path is
   * provided, the task is a no-op that is meant to refresh the monitoring status.
   */
  paths: string[];
  /** The kind of the task which must match the path, if path is provided. */
  kind: WarehouseSyncKind;
  /** The mode to sync the task. Ignored if path is not provided. */
  mode: WarehouseSyncMode;
  /**
   * The only warehouse to sync the task to. Usually only specified when repairing a particular warehouse. Normally,
   * this field should not be specified, so that the task will be synced to all the configured warehouses (excluding
   * internal sync). If the specified warehouse is not one of the configured warehouses, the task will be ignored.
   * Internal sync only happens when this field is set to INTERNAL.
   */
  provider: WarehouseProvider;
  /** The bundle flow that created the path, such as IMMUTABLE and OBJECT_STORAGE. */
  flow: WarehauserBundleFlow;
  /** The time range to delete before syncing the paths. */
  preDelete: PutSyncTaskRequest.PreDeleteTimeRange | null;
  /** Sync the silver schema such as copying after transformation. If this is not set, the task is meant for bronze. */
  silver: SilverSync | null;
  /** If set, sync signals will be sent to the recipient. Usually used to notify a waiting workflow. */
  signalRecipient: BundleSyncSignalRecipient | null;
}

export namespace PutSyncTaskRequest {
  export interface PreDeleteTimeRange {
    start: protobuf.timestamp | null;
    end: protobuf.timestamp | null;
  }
}

export interface PutSyncTaskResponse {
  taskId: string;
}

export interface PeekSyncTasksRequest {
  orgId: string;
  /**
   * The limit of tasks to peek for each of the queues; default to 1.
   * The total number of tasks in the response can be up to limit * (count(warehouses) * count(kinds) + 1).
   */
  limit: number;
}

export interface PeekSyncTasksResponse {
  orgId: string;
  limit: number;
  orgTasks: WarehouseBundleSyncTask[];
  warehouses: PeekSyncTasksResponse.ByWarehouse[];
}

export namespace PeekSyncTasksResponse {
  export interface ByWarehouse {
    provider: WarehouseProvider;
    kinds: PeekSyncTasksResponse.ByKind[];
  }

  export interface ByKind {
    kind: WarehouseSyncKind;
    orgWarehouseKindTasks: WarehouseBundleSyncTask[];
  }
}

export interface RemoveSyncTasksRequest {
  orgId: string;
  /**
   * org_task_store stores tasks for an org before being dispatched based on configured warehouses of the org.
   * There is one such store per org. Tasks for an org are first put in this store to be dispatched.
   */
  orgTaskStore?: RemoveSyncTasksRequest.OrgTasks | null;
  /**
   * org_warehouse_kind_task_store stores tasks of a particular warehouse and a particular kind for an org. There are
   * count(warehouse) * count(kind) such stores per org. Tasks in these stores are dispatched from the org_task_store.
   */
  orgWarehouseKindTaskStore?: RemoveSyncTasksRequest.OrgWarehouseKindTasks | null;
  /** each line is a task id of the selected task store, such as 20230320221047.487-4IRL3GuEhQg. */
  taskIds: string;
}

export namespace RemoveSyncTasksRequest {
  export interface OrgTasks {
  }

  export interface OrgWarehouseKindTasks {
    provider: WarehouseProvider;
    kind: WarehouseSyncKind;
  }

  export enum task_store {
    /**
     * org_task_store stores tasks for an org before being dispatched based on configured warehouses of the org.
     * There is one such store per org. Tasks for an org are first put in this store to be dispatched.
     */
    orgTaskStore = 2,
    /**
     * org_warehouse_kind_task_store stores tasks of a particular warehouse and a particular kind for an org. There are
     * count(warehouse) * count(kind) such stores per org. Tasks in these stores are dispatched from the org_task_store.
     */
    orgWarehouseKindTaskStore = 3
  }

  export function task_store_oneof(m: RemoveSyncTasksRequest): { opt: task_store.orgTaskStore, val: RemoveSyncTasksRequest.OrgTasks } | { opt: task_store.orgWarehouseKindTaskStore, val: RemoveSyncTasksRequest.OrgWarehouseKindTasks } | null {
    if (m.orgTaskStore != null) { return { opt: task_store.orgTaskStore, val: m.orgTaskStore } }
    if (m.orgWarehouseKindTaskStore != null) { return { opt: task_store.orgWarehouseKindTaskStore, val: m.orgWarehouseKindTaskStore } }
    return null;
  }
}

export enum WarehauserBundleFlow {
  /** The INVALID flow referring to the event stream, aka Dataflow/CenterStage, which is not a bundle flow. */
  WAREHAUSER_BUNDLE_FLOW_INVALID = 0,
  /** The flow with a fixed delay, such as 24 hours. This is deprecated, because OBJECT_STORAGE has lower latency. */
  WAREHAUSER_BUNDLE_FLOW_FIXED_DELAY = 1,
  /** The flow that is based on the final cook notification. */
  WAREHAUSER_BUNDLE_FLOW_OBJECT_STORAGE = 2,
  /** The flow for internal sync. This is not used since internal sync now has the same data as non-internal sync. */
  WAREHAUSER_BUNDLE_FLOW_INTERNAL = 3,
  /** The flow that is based on the immutable cook going through NATS and CenterStage. */
  WAREHAUSER_BUNDLE_FLOW_IMMUTABLE = 4
}

export enum WarehauserBundleMode {
  WAREHAUSER_BUNDLE_MODE_INVALID = 0,
  WAREHAUSER_BUNDLE_MODE_APPEND = 1,
  WAREHAUSER_BUNDLE_MODE_REPLACE = 2,
  WAREHAUSER_BUNDLE_MODE_REAPPEND = 3
}

export interface WarehauserBundlerTask {
  orgId: string;
  provider: WarehouseProvider;
  objectStorageDetails?: WarehauserBundlerTask.ObjectStorage | null;
  immutableDetails?: WarehauserBundlerTask.Immutable | null;
  bufferPartitionDetails?: WarehauserBundlerTask.BufferPartition | null;
  bundlePartitionDetails?: WarehauserBundlerTask.BundlePartition | null;
  adhocDetails?: WarehauserBundlerTask.Adhoc | null;
  /** If set, sync signals will be sent to the recipient. Usually used to notify a waiting workflow. */
  signalRecipient: BundleSyncSignalRecipient | null;
}

export namespace WarehauserBundlerTask {
  export interface ObjectStorage {
    /** the id of the bundle mapped to a list of pages in the store defined by the prep workflow. */
    bundleId: string;
    bundleMode: WarehauserBundleMode;
  }

  export interface Immutable {
    /** the prefix for the bundle, e.g., the id of the job that creates all the tasks in the event time range. */
    prefix: string;
    /** if set, only events on or after the start will be included in the bundle among the events in the listed pages. */
    eventTimeStart: protobuf.timestamp | null;
    /** if set, only events before the end will be included in the bundle among the events in the listed pages. */
    eventTimeEnd: protobuf.timestamp | null;
    /** the watermark for the listed pages in the page scanning stream. */
    watermark: string;
    userIds: protobuf.int64[];
    sessionIds: protobuf.int64[];
    pageIds: protobuf.int64[];
  }

  /** Buffer events within a partition range from a list of pages to BigTable by partitions and shards. */
  export interface BufferPartition {
    /** the id of a group of related bundler tasks, e.g., the id of the job that creates the group of tasks. */
    groupId: string;
    /** the range start (closed) of the event partitions from the pages that will be buffered. */
    partitionStart: string;
    /** the range end (open) of the event partitions from the pages that will be buffered. */
    partitionEnd: string;
    userIds: protobuf.int64[];
    sessionIds: protobuf.int64[];
    pageIds: protobuf.int64[];
  }

  /** Bundle shards of events in a partition buffered in BigTable to GCS. */
  export interface BundlePartition {
    /** the id of a group of related bundler tasks, e.g., the id of the job that creates the group of tasks. */
    groupId: string;
    /** the event partition buffered in BigTable as the source to GCS files. */
    partition: string;
    /** the range start (closed) of the shards in the partition to be bundled. */
    shardStart: number;
    /** the range end (open) of the shards in the partition to be bundled. */
    shardEnd: number;
    /** the target GCS files to save the events in the range of shards. */
    paths: string[];
  }

  /** Create an isolated bundle that will not be synced, mostly for troubleshooting/monitoring purposes. */
  export interface Adhoc {
    /** if set, only events on or after the start will be included in the bundle among the events in the listed pages. */
    eventTimeStart: protobuf.timestamp | null;
    /** if set, only events before the end will be included in the bundle among the events in the listed pages. */
    eventTimeEnd: protobuf.timestamp | null;
    userIds: protobuf.int64[];
    sessionIds: protobuf.int64[];
    pageIds: protobuf.int64[];
    /**
     * if omitted, a name will be automatically generated for this request.
     * do not include extension like .parquet.
     */
    bundleName: string;
    /** if omitted, the bundle will be created in the root adhoc directory. */
    subDirectory: string;
  }

  export enum flow_details {
    objectStorageDetails = 5,
    immutableDetails = 6,
    bufferPartitionDetails = 9,
    bundlePartitionDetails = 10,
    adhocDetails = 12
  }

  export function flow_details_oneof(m: WarehauserBundlerTask): { opt: flow_details.adhocDetails, val: WarehauserBundlerTask.Adhoc } | { opt: flow_details.bufferPartitionDetails, val: WarehauserBundlerTask.BufferPartition } | { opt: flow_details.bundlePartitionDetails, val: WarehauserBundlerTask.BundlePartition } | { opt: flow_details.immutableDetails, val: WarehauserBundlerTask.Immutable } | { opt: flow_details.objectStorageDetails, val: WarehauserBundlerTask.ObjectStorage } | null {
    if (m.objectStorageDetails != null) { return { opt: flow_details.objectStorageDetails, val: m.objectStorageDetails } }
    if (m.immutableDetails != null) { return { opt: flow_details.immutableDetails, val: m.immutableDetails } }
    if (m.bufferPartitionDetails != null) { return { opt: flow_details.bufferPartitionDetails, val: m.bufferPartitionDetails } }
    if (m.bundlePartitionDetails != null) { return { opt: flow_details.bundlePartitionDetails, val: m.bundlePartitionDetails } }
    if (m.adhocDetails != null) { return { opt: flow_details.adhocDetails, val: m.adhocDetails } }
    return null;
  }
}

export interface ReconcileSyncResponse {
  orgsStopped: string[];
  orgsWithTasksPurged: string[];
}

export interface ReconcileOrgRequest {
  orgId: string;
}

export interface ReconcileOrgResponse {
  /** If true, this org's sync workflow was stopped. */
  stopped: boolean;
  /** If true this org's bigtable tasks were purged. */
  tasksPurged: boolean;
}

export interface GetSyncHistoryRequest {
  orgId: string;
  /** The limit of logs to get; default to 10. */
  limit: number;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export interface GetSyncHistoryResponse {
  logs: WarehouseStatementEventLog[];
}

/** MonitoringStatus is persisted to the monitoring store. */
export interface MonitoringStatus {
  totalAlertingOrgs: number;
  firstAlertingOrgs: AlertingOrg[];
  totalSnoozingOrgs: number;
  firstSnoozingOrgs: AlertingOrg[];
}

export interface AlertingOrg {
  orgId: string;
  alertingWarehouses: AlertingOrg.Warehouse[];
}

export namespace AlertingOrg {
  export interface Warehouse {
    provider: WarehouseProvider;
    automaticSnoozeSince: protobuf.timestamp | null;
    manualSnoozeUntil: protobuf.timestamp | null;
    missingLastAuth: boolean;
    alerts: AlertingOrg.Warehouse.Alert[];
  }

  export namespace Warehouse {
    export interface Alert {
      name: string;
      lastSuccess: protobuf.timestamp | null;
      elapsed: protobuf.duration | null;
      threshold: protobuf.duration | null;
    }
  }
}

export interface SnoozeOrgWarehouseRequest {
  orgId: string;
  provider: WarehouseProvider;
  /** snooze for a custom duration unless configuration is updated, usually up to the expected resolution of the ongoing issue. */
  untilConfigurationChangeOrDurationElapsed?: SnoozeOrgWarehouseRequest.DurationElapsed | null;
  /** snooze for a predefined very long duration, effectively until the configuration is updated. */
  untilOnlyConfigurationChange?: SnoozeOrgWarehouseRequest.ConfigurationChange | null;
  /**
   * normally the snooze will be picked up by the next status refresh in a few minutes;
   * forcing the expensive status refresh now will see the effect immediately.
   */
  forceStatusRefreshNow: boolean;
}

export namespace SnoozeOrgWarehouseRequest {
  export interface DurationElapsed {
    duration: protobuf.duration | null;
  }

  export interface ConfigurationChange {
  }

  export enum until {
    /** snooze for a custom duration unless configuration is updated, usually up to the expected resolution of the ongoing issue. */
    untilConfigurationChangeOrDurationElapsed = 3,
    /** snooze for a predefined very long duration, effectively until the configuration is updated. */
    untilOnlyConfigurationChange = 4
  }

  export function until_oneof(m: SnoozeOrgWarehouseRequest): { opt: until.untilConfigurationChangeOrDurationElapsed, val: SnoozeOrgWarehouseRequest.DurationElapsed } | { opt: until.untilOnlyConfigurationChange, val: SnoozeOrgWarehouseRequest.ConfigurationChange } | null {
    if (m.untilConfigurationChangeOrDurationElapsed != null) { return { opt: until.untilConfigurationChangeOrDurationElapsed, val: m.untilConfigurationChangeOrDurationElapsed } }
    if (m.untilOnlyConfigurationChange != null) { return { opt: until.untilOnlyConfigurationChange, val: m.untilOnlyConfigurationChange } }
    return null;
  }
}

export interface UnsnoozeOrgWarehouseRequest {
  orgId: string;
  provider: WarehouseProvider;
  /** remove the automatic snooze caused by user errors if the snooze is present. */
  unsnoozeAutomaticSnooze: boolean;
  /** remove the manual snooze set by SnoozeOrgWarehouse if the snooze is present. */
  unsnoozeManualSnooze: boolean;
  /**
   * normally the unsnooze will be picked up by the next status refresh in a few minutes;
   * forcing the expensive status refresh now will see the effect immediately.
   */
  forceStatusRefreshNow: boolean;
}

export interface ManualFix20221220SnowflakeUpdatedTimeShouldBeUTC {
}

export interface ManualFix20230207SnowflakeDescribeStorageIntegration {
  storageIntegration: string;
}

export interface ManualFix20230209SnowflakePatchStorageIntegration {
  storageIntegration: string;
  serviceAccount: string;
}

export interface ManualFix20230214SnowflakeCleanInternalStage {
}

export interface ManualFix20240405RedshiftFixSuperColumns {
}

export interface ManualFix20240909SetObjectStorageLiveSyncStartIfMissing {
  liveSyncInitialBundleWatermark: protobuf.timestamp | null;
}

export interface ManualFix20241029ClearOrgStatusWithoutConfig {
}

export interface ManualFix20241113BigQueryDeleteEventsByPageStartCutoff {
  /** events in pages started after cutoff will be deleted. */
  cutoff: protobuf.timestamp | null;
  notDryRun: boolean;
}

export interface ManualFix20241119SnowflakeDeleteEventsByPageStartCutoff {
  /** events in pages started after cutoff will be deleted. */
  cutoff: protobuf.timestamp | null;
  notDryRun: boolean;
}

export interface ManualFix20250110NamedElementTableName {
  /** defaults to dry run */
  notDryRun: boolean;
}

export interface ManualFix20250223BackfillObjectStorageMissingPages {
  /** the start of the range [start, end) to scan pages by start to look for unmapped pages. */
  start: protobuf.timestamp | null;
  /** the end of the range [start, end) to scan pages by start to look for unmapped pages. */
  end: protobuf.timestamp | null;
  /**
   * the first bundle id to use for unmapped pages; will automatically move to the next bundle ids if needed.
   * use dry run to make sure bundle ids will not conflict.
   */
  firstBundleId: string;
  maxPagesPerBundle: number;
  notDryRun: boolean;
}

export interface ManualFix20250502RemoveDuplicatedEvents {
  provider: WarehouseProvider;
  /** the start of the event time to look for duplicates in the events table. */
  start: protobuf.timestamp | null;
  /** the end of the event time to look for duplicates in the events table. */
  end: protobuf.timestamp | null;
  notDryRun: boolean;
}

/**
 * ManualFix represent a manual fix to a specific warehouse configuration for an org since it is easier to track
 * progress and retries by org and warehouse configuration pairs. If an org does not have the target configuration of
 * a manual fix, the org is skipped and considered fixed because there is no need to fix. Each manual fix should be
 * idempotent in case there will be multiple attempts.
 */
export interface ManualFix {
  fix20221220?: ManualFix20221220SnowflakeUpdatedTimeShouldBeUTC | null;
  fix20230207?: ManualFix20230207SnowflakeDescribeStorageIntegration | null;
  fix20230209?: ManualFix20230209SnowflakePatchStorageIntegration | null;
  fix20230214?: ManualFix20230214SnowflakeCleanInternalStage | null;
  fix20240405?: ManualFix20240405RedshiftFixSuperColumns | null;
  fix20240909?: ManualFix20240909SetObjectStorageLiveSyncStartIfMissing | null;
  fix20241029?: ManualFix20241029ClearOrgStatusWithoutConfig | null;
  fix20241113?: ManualFix20241113BigQueryDeleteEventsByPageStartCutoff | null;
  fix20241119?: ManualFix20241119SnowflakeDeleteEventsByPageStartCutoff | null;
  /** Fix for https://fullstory.atlassian.net/browse/VAL-9094 */
  fix20250110?: ManualFix20250110NamedElementTableName | null;
  fix20250223?: ManualFix20250223BackfillObjectStorageMissingPages | null;
  fix20250502?: ManualFix20250502RemoveDuplicatedEvents | null;
}

/**
 * ManualFix represent a manual fix to a specific warehouse configuration for an org since it is easier to track
 * progress and retries by org and warehouse configuration pairs. If an org does not have the target configuration of
 * a manual fix, the org is skipped and considered fixed because there is no need to fix. Each manual fix should be
 * idempotent in case there will be multiple attempts.
 */
export namespace ManualFix {
  export enum manual_fix {
    fix20221220 = 1,
    fix20230207 = 2,
    fix20230209 = 3,
    fix20230214 = 4,
    fix20240405 = 5,
    fix20240909 = 6,
    fix20241029 = 8,
    fix20241113 = 9,
    fix20241119 = 10,
    /** Fix for https://fullstory.atlassian.net/browse/VAL-9094 */
    fix20250110 = 11,
    fix20250223 = 12,
    fix20250502 = 13
  }

  export function manual_fix_oneof(m: ManualFix): { opt: manual_fix.fix20221220, val: ManualFix20221220SnowflakeUpdatedTimeShouldBeUTC } | { opt: manual_fix.fix20230207, val: ManualFix20230207SnowflakeDescribeStorageIntegration } | { opt: manual_fix.fix20230209, val: ManualFix20230209SnowflakePatchStorageIntegration } | { opt: manual_fix.fix20230214, val: ManualFix20230214SnowflakeCleanInternalStage } | { opt: manual_fix.fix20240405, val: ManualFix20240405RedshiftFixSuperColumns } | { opt: manual_fix.fix20240909, val: ManualFix20240909SetObjectStorageLiveSyncStartIfMissing } | { opt: manual_fix.fix20241029, val: ManualFix20241029ClearOrgStatusWithoutConfig } | { opt: manual_fix.fix20241113, val: ManualFix20241113BigQueryDeleteEventsByPageStartCutoff } | { opt: manual_fix.fix20241119, val: ManualFix20241119SnowflakeDeleteEventsByPageStartCutoff } | { opt: manual_fix.fix20250110, val: ManualFix20250110NamedElementTableName } | { opt: manual_fix.fix20250223, val: ManualFix20250223BackfillObjectStorageMissingPages } | { opt: manual_fix.fix20250502, val: ManualFix20250502RemoveDuplicatedEvents } | null {
    if (m.fix20221220 != null) { return { opt: manual_fix.fix20221220, val: m.fix20221220 } }
    if (m.fix20230207 != null) { return { opt: manual_fix.fix20230207, val: m.fix20230207 } }
    if (m.fix20230209 != null) { return { opt: manual_fix.fix20230209, val: m.fix20230209 } }
    if (m.fix20230214 != null) { return { opt: manual_fix.fix20230214, val: m.fix20230214 } }
    if (m.fix20240405 != null) { return { opt: manual_fix.fix20240405, val: m.fix20240405 } }
    if (m.fix20240909 != null) { return { opt: manual_fix.fix20240909, val: m.fix20240909 } }
    if (m.fix20241029 != null) { return { opt: manual_fix.fix20241029, val: m.fix20241029 } }
    if (m.fix20241113 != null) { return { opt: manual_fix.fix20241113, val: m.fix20241113 } }
    if (m.fix20241119 != null) { return { opt: manual_fix.fix20241119, val: m.fix20241119 } }
    if (m.fix20250110 != null) { return { opt: manual_fix.fix20250110, val: m.fix20250110 } }
    if (m.fix20250223 != null) { return { opt: manual_fix.fix20250223, val: m.fix20250223 } }
    if (m.fix20250502 != null) { return { opt: manual_fix.fix20250502, val: m.fix20250502 } }
    return null;
  }
}

export interface ManualFixOrgRequest {
  orgId: string;
  manualFix: ManualFix | null;
}

export interface ManualFixOrgsRequest {
  orgIds: string[];
  manualFix: ManualFix | null;
}

export interface SnowflakeQueryHistory {
  queryId: string;
  queryText: string;
  databaseName: string;
  schemaName: string | null;
  queryType: string;
  sessionId: protobuf.int64;
  userName: string;
  userType: string | null;
  userDatabaseName: string | null;
  userSchemaName: string | null;
  roleName: string;
  warehouseName: string;
  warehouseSize: string | null;
  warehouseType: string;
  clusterNumber: protobuf.int64 | null;
  queryTag: string;
  executionStatus: string;
  errorCode: protobuf.int64 | null;
  errorMessage: string | null;
  startTime: string;
  endTime: string;
  totalElapsedTime: protobuf.int64;
  bytesScanned: protobuf.int64;
  rowsProduced: protobuf.int64;
  compilationTime: protobuf.int64;
  executionTime: protobuf.int64;
  queuedProvisioningTime: protobuf.int64;
  queuedRepairTime: protobuf.int64;
  queuedOverloadTime: protobuf.int64;
  transactionBlockedTime: protobuf.int64;
  outboundDataTransferCloud: string | null;
  outboundDataTransferRegion: string | null;
  outboundDataTransferBytes: protobuf.int64;
  inboundDataTransferCloud: string | null;
  inboundDataTransferRegion: string | null;
  inboundDataTransferBytes: protobuf.int64;
  creditsUsedCloudServices: number;
  listExternalFileTime: protobuf.int64;
  releaseVersion: string;
  externalFunctionTotalInvocations: protobuf.int64;
  externalFunctionTotalSentRows: protobuf.int64;
  externalFunctionTotalReceivedRows: protobuf.int64;
  externalFunctionTotalSentBytes: protobuf.int64;
  externalFunctionTotalReceivedBytes: protobuf.int64;
  isClientGeneratedStatement: boolean;
  queryHash: string;
  queryHashVersion: protobuf.int64;
  queryParameterizedHash: string;
  queryParameterizedHashVersion: protobuf.int64;
  transactionId: protobuf.int64;
  queryAccelerationBytesScanned: protobuf.int64;
  queryAccelerationPartitionsScanned: protobuf.int64;
  queryAccelerationUpperLimitScaleFactor: protobuf.int64;
  bytesWrittenToResult: protobuf.int64;
  rowsWrittenToResult: protobuf.int64;
  rowsInserted: protobuf.int64;
  queryRetryTime: protobuf.int64;
  queryRetryCause: string | null;
  faultHandlingTime: protobuf.int64;
}

export interface GetSnowflakeQueryHistoryRequest {
  orgId: string;
  /** default to 10. */
  limit: number;
}

export interface GetSnowflakeQueryHistoryResponse {
  queryHistory: SnowflakeQueryHistory[];
}

export interface CreateBackfillRequest {
  orgId: string;
  flow: WarehauserBundleFlow;
  /**
   * The destination for the backfill, which must be one of the allowed destination for the flow.
   * Note that INVALID means all the non-internal destinations.
   */
  destination: WarehouseProvider;
  /** the timestamp for the start of the backfill */
  start: protobuf.timestamp | null;
  /** the timestamp for the start of the backfill */
  end: protobuf.timestamp | null;
  /** The reason for running this backfill. Required. */
  reason: Backfill.Reason;
  /** Describes more about why this backfill was run. */
  description: string;
}

export interface CreateBackfillResponse {
  backfill: Backfill | null;
}

export interface CreateInternalBackfillRequest {
  orgId: string;
  /** the timestamp for the start of the backfill */
  start: protobuf.timestamp | null;
  /** the timestamp for the start of the backfill */
  end: protobuf.timestamp | null;
  /** The reason for running this backfill. Required. */
  reason: Backfill.Reason;
  /** Describes more about why this backfill was run. */
  description: string;
}

export interface CreateInternalBackfillResponse {
  backfill: Backfill | null;
}

export interface CreateBackfillsForOrgsRequest {
  /** the timestamp for the start of the backfill */
  start: protobuf.timestamp | null;
  /** the timestamp for the start of the backfill */
  end: protobuf.timestamp | null;
  /** The reason for running this backfill. Required. */
  reason: Backfill.Reason;
  /** Describes more about why this backfill was run. */
  description: string;
  includeAnyOf: WarehouseProvider[];
  excludeAnyOf: WarehouseProvider[];
  includeAnyOfOrgIds: string[];
  excludeAnyOfOrgIds: string[];
}

export interface CreateBackfillsForOrgsResponse {
}

export interface GetBackfillRequest {
  orgId: string;
  id: string;
}

export interface GetBackfillResponse {
  backfill: Backfill | null;
  progress: BackfillProgress | null;
}

export interface ListBackfillsRequest {
  /** If provided, org to filter by */
  orgId: string;
  /** if non-zero, state to filter by */
  state: Backfill.State;
}

export interface ListBackfillResponse {
  backfills: Backfill[];
}

export interface CancelBackfillRequest {
  orgId: string;
  backfillId: string;
  reason: string;
}

export interface CancelBackfillResponse {
  backfill: Backfill | null;
}

export interface Backfill {
  id: string;
  orgId: string;
  /** the initiator of the backfill */
  createdBy: string;
  /** when the backfill was created */
  created: protobuf.timestamp | null;
  /** when the backfill was completed */
  completed: protobuf.timestamp | null;
  /** the destination to backfill */
  destination: WarehouseProvider;
  /** the start time for the backfill */
  start: protobuf.timestamp | null;
  /** the end time for the backfill */
  end: protobuf.timestamp | null;
  /** the reason for running the backfill */
  reason: Backfill.Reason;
  /** additional information about why this backfill was run */
  description: string;
  /** the current state of the backfill */
  state: Backfill.State;
  /** If canceled, will contain the message. If failed, will contain the failure that caused the failure. */
  failureDetails: string;
  /** The workflow execution ID, required to be able to query details about the workflow in the future. */
  temporalWorkflowExecutionId: string;
  /** The run ID, generated everytime the workflow is restarted due to a retry, failure, cont'd as new. */
  temporalWorkflowExecutionRunId: string;
  /** The mode of the backfill */
  mode: WarehouseSyncMode;
}

export namespace Backfill {
  export enum Reason {
    REASON_INVALID = 0,
    /** Indicates the initial backfill that is usually run when an org first onboards. */
    REASON_INITIAL = 1,
    REASON_OUTAGE = 2,
    REASON_RETROACTIVE_FEATURE = 3,
    REASON_DATA_FIX = 4
  }

  export enum State {
    STATE_UNKNOWN = 0,
    STATE_SCHEDULED = 1,
    STATE_IN_PROGRESS = 2,
    STATE_COMPLETED = 3,
    STATE_CANCELED = 4,
    STATE_FAILED = 5
  }
}

export interface BackfillProgress {
  groups: BackfillGroupProgress[];
}

export interface BackfillGroupProgress {
  /** Use the group_id to identify the group of tasks that are being processed. */
  groupId: string;
  start: protobuf.timestamp | null;
  end: protobuf.timestamp | null;
  status: BackfillGroupProgress.Status;
  workflowId: string;
  errorMessage: string;
}

export namespace BackfillGroupProgress {
  export enum Status {
    STATUS_UNKNOWN = 0,
    STATUS_CREATED = 1,
    STATUS_PROCESSED = 2,
    STATUS_SYNC_SCHEDULED = 3,
    STATUS_COMPLETED = 4,
    STATUS_ERRORED = 5
  }
}

export interface EventPrepConfiguration {
  centerstage: EventPrepConfiguration.Centerstage | null;
  objectStorage: EventPrepConfiguration.ObjectStorage | null;
}

export namespace EventPrepConfiguration {
  export interface Centerstage {
    enabled: boolean;
  }

  export interface ObjectStorage {
    enabled: boolean;
    /** Delay means that a page will be processed only when now - final_cook_notified >= delay, e.g., 10 minutes. */
    delay: protobuf.duration | null;
    /** Interval is how often the delays of pages are checked, e.g., every hour. */
    interval: protobuf.duration | null;
  }
}

export interface MeasureDurationResponse {
  duration: protobuf.duration | null;
}

export interface SetSilverEnabledRequest {
  orgId: string;
  provider: WarehouseProvider;
  silverEnabled: boolean;
}

export interface SetSilverEnabledResponse {
  silverEnabled: boolean;
}

export interface SetBronzeDisabledRequest {
  orgId: string;
  provider: WarehouseProvider;
  bronzeDisabled: boolean;
}

export interface SetBronzeDisabledResponse {
  bronzeDisabled: boolean;
}

export interface ExportTableResult {
  metadataPath: string;
  paths: string[];
  /**
   * The maximum timestamp occuring within the export. This timestamp will eventually be saved
   * as the low watermark for the table.
   */
  pendingWatermark: protobuf.timestamp | null;
}

export interface BundleMetadata {
  tableName: string;
  tableDescription: string;
  schema: BundleMetadata.Field[];
  timePartitioning: BundleMetadata.TimePartitioning | null;
  clustering: BundleMetadata.Clustering | null;
  tableConstraints: BundleMetadata.TableConstraints | null;
  labels: { [key: string]: string };
  /** The minimum partition value occuring in files for this bundle. */
  minPartitionValue: protobuf.timestamp | null;
  /** The maximum partition value occuring in files for this bundle. */
  maxPartitionValue: protobuf.timestamp | null;
  /** All of the distinct partition values occuring in files for this bundle. */
  partitionValues: protobuf.timestamp[];
  mergeStrategy: BundleMetadata.MergeStrategy;
}

export namespace BundleMetadata {
  /** https://cloud.google.com/bigquery/docs/reference/standard-sql/data-types#data_type_list */
  export enum DataType {
    DATA_TYPE_UNKNOWN = 0,
    /** A value that can be either TRUE or FALSE. */
    DATA_TYPE_BOOL = 1,
    /** Variable-length binary data. */
    DATA_TYPE_BYTES = 2,
    /** A Gregorian calendar date, independent of time zone. */
    DATA_TYPE_DATE = 3,
    /** A Gregorian date and a time, as they might be displayed on a watch, independent of time zone. */
    DATA_TYPE_DATETIME = 4,
    /** A collection of points, linestrings, and polygons, which is represented as a point set, or a subset of the surface of the Earth. */
    DATA_TYPE_GEOGRAPHY = 5,
    /** A duration of time, without referring to any specific point in time. */
    DATA_TYPE_INTERVAL = 6,
    /** Represents JSON, a lightweight data-interchange format. */
    DATA_TYPE_JSON = 7,
    /** A 64-bit integer. */
    DATA_TYPE_INT64 = 8,
    /** A decimal value with precision of 38 digits, scale of 9. */
    DATA_TYPE_NUMERIC = 9,
    /** A decimal value with precision of 76.76 digits (the 77th digit is partial), scale of 38. */
    DATA_TYPE_BIGNUMERIC = 10,
    /** An approximate double precision numeric value. */
    DATA_TYPE_FLOAT64 = 11,
    /** Contiguous range between two dates, datetimes, or timestamps. */
    DATA_TYPE_RANGE = 12,
    /** Variable-length character data. */
    DATA_TYPE_STRING = 13,
    /** Container of ordered fields. */
    DATA_TYPE_STRUCT = 14,
    /** A time of day, as might be displayed on a clock, independent of a specific date and time zone. */
    DATA_TYPE_TIME = 15,
    /** A timestamp value represents an absolute point in time, independent of any time zone or convention such as daylight saving time (DST). */
    DATA_TYPE_TIMESTAMP = 16
  }

  /**
   * Field represents a single column in a table. Is heavily based of of the BigQuery representation:
   * https://pkg.go.dev/cloud.google.com/go/bigquery#FieldSchema
   * However, we will use this to represent the schema for any table and any warehouse (BigQuery, Snowflake, Redshift, etc)
   */
  export interface Field {
    /** The name of the field that will appear as a column. */
    name: string;
    /** A text description of the field to help the end user understand what it should be used for. */
    description: string;
    /** The type of data that it contains, if repeated is true, this will be an array of this type. */
    dataType: BundleMetadata.DataType;
    /** If true, this field is an array of type "data_type" */
    isRepeated: boolean;
    /** If true, this field is non-null. If false, this field is nullable. */
    isRequired: boolean;
    /**
     * Used to specify the default value of a field
     * using a SQL expression.  It can only be set for top level fields (columns).
     * 
     * You can use struct or array expression to specify default value for the
     * entire struct or array. The valid SQL expressions are:
     * 
     * - Literals for all data types, including STRUCT and ARRAY.
     * - The following functions:
     *   - CURRENT_TIMESTAMP
     *   - CURRENT_TIME
     *   - CURRENT_DATE
     *   - CURRENT_DATETIME
     *   - GENERATE_UUID
     *   - RAND
     *   - SESSION_USER
     *   - ST_GEOGPOINT
     *   - Struct or array composed with the above allowed functions, for example:
     *       [CURRENT_DATE(), DATE '2020-01-01']"
     */
    defaultValueExpression: string;
    /** If data_type is DATA_TYPE_STRUCT, this will contain the fields of the struct. */
    schema: BundleMetadata.Field[];
  }

  export enum TimePartitioningType {
    TIME_PARTITIONING_TYPE_UNKNOWN = 0,
    TIME_PARTITIONING_TYPE_HOUR = 1,
    TIME_PARTITIONING_TYPE_DAY = 2,
    TIME_PARTITIONING_TYPE_MONTH = 3,
    TIME_PARTITIONING_TYPE_YEAR = 4
  }

  export interface TimePartitioning {
    type: BundleMetadata.TimePartitioningType;
    field: string;
  }

  export interface Clustering {
    fields: string[];
  }

  export interface PrimaryKey {
    columns: string[];
  }

  export interface Table {
    projectId: string;
    datasetId: string;
    tableId: string;
  }

  export interface ColumnReference {
    /** ReferencingColumn is the column in the current table that composes the foreign key. */
    referencingColumn: string;
    /**
     * ReferencedColumn is the column in the primary key of the foreign table that
     * is referenced by the ReferencingColumn.
     */
    referencedColumn: string;
  }

  export interface ForeignKey {
    /** Foreign key constraint name. */
    name: string;
    /** Table that holds the primary key and is referenced by this foreign key. */
    referencedTable: BundleMetadata.Table | null;
    /** Columns that compose the foreign key. */
    columnReferences: BundleMetadata.ColumnReference[];
  }

  export interface TableConstraints {
    /** PrimaryKey constraint on a table's columns. This key is not strictly enforced. */
    primaryKey: BundleMetadata.PrimaryKey | null;
    /** ForeignKeys represent a list of foreign keys constraints. Foreign keys are not enforced. */
    foreignKeys: BundleMetadata.ForeignKey[];
  }

  export enum MergeStrategy {
    MERGE_STRATEGY_UNKNOWN = 0,
    /**
     * On merge, only look at the partitions for which data is present in the source bundle. This
     * drastically limits the number of partitions that need to be processed and the amount of data
     * that needs to be scanned.
     */
    MERGE_STRATEGY_PRUNE_PARTITIONS = 1,
    /**
     * On merge, do a full table scan to find any matching rows. This ensures no duplicates are
     * introduced into the table.
     */
    MERGE_STRATEGY_FULL = 2
  }
}

export interface CompareWarehouseEventsRequest {
  orgId: string;
  /**
   * if set, only events on or after the start will be included in the bundle.
   * Note that the timerange should be at most 24 hours to control query costs. Anything longer should go through adhoc bundling.
   */
  eventTimeStart: protobuf.timestamp | null;
  /**
   * if set, only events before the end will be included in the bundle.
   * Note that the timerange should be at most 24 hours to control query costs. Anything longer should go through adhoc bundling.
   */
  eventTimeEnd: protobuf.timestamp | null;
  scanPagesByStart?: ScanPages | null;
  pagesList?: ListPages | null;
  /**
   * if omitted, a name will be automatically generated for this request.
   * do not include extension like .parquet.
   */
  bundleName: string;
}

export namespace CompareWarehouseEventsRequest {
  export enum pages {
    scanPagesByStart = 4,
    pagesList = 5
  }

  export function pages_oneof(m: CompareWarehouseEventsRequest): { opt: pages.pagesList, val: ListPages } | { opt: pages.scanPagesByStart, val: ScanPages } | null {
    if (m.scanPagesByStart != null) { return { opt: pages.scanPagesByStart, val: m.scanPagesByStart } }
    if (m.pagesList != null) { return { opt: pages.pagesList, val: m.pagesList } }
    return null;
  }
}

export interface ScanPages {
  /**
   * the start to scan pages by starts (on or after the start will be included).
   * it may take up to 24 hours for pages to be consistent and able to be scanned.
   */
  start: protobuf.timestamp | null;
  /**
   * the end to scan pages by starts (before the end will be included).
   * it may take up to 24 hours for pages to be consistent and able to be scanned.
   */
  end: protobuf.timestamp | null;
}

export interface ListPages {
  args: schema.PageArgsProto[];
}

export interface MismatchedPage {
  pageArgs: schema.PageArgsProto | null;
  /** the number of events in the warehouse for this page */
  warehouseCount: protobuf.int64;
  /** the number of events in the source bundle for this page */
  sourceCount: protobuf.int64;
}

export interface CompareWarehouseEventsResponse {
  mismatchedPages: MismatchedPage[];
  /** event count in warehouse / event count in source bundle over the request period */
  eventCountRatio: number;
  jobIds: string[];
}
